(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5],{

/***/ 13379:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');
exports.Z = _default;

/***/ }),

/***/ 61205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15-5-2.18L7 18V5h10v13z"
}), 'BookmarkBorder');
exports.Z = _default;

/***/ }),

/***/ 50594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
exports.Z = _default;

/***/ }),

/***/ 76638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');
exports.Z = _default;

/***/ }),

/***/ 7444:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
}), 'Reorder');
exports.Z = _default;

/***/ }),

/***/ 63081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f9": function() { return /* binding */ deleteSearchQuery; },
  "XM": function() { return /* binding */ getSearchQueries; },
  "pI": function() { return /* binding */ saveSearchQuery; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/search-queries/search-queries.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SearchQueriesStatic;

(function (SearchQueriesStatic) {
  SearchQueriesStatic["save"] = "/v2/clients/save-queries";
  SearchQueriesStatic["list"] = "/v2/clients/search-queries";
})(SearchQueriesStatic || (SearchQueriesStatic = {}));

var SearchQueriesDynamic = {
  /**
   * @member {string}
   * @method DELETE
   * @version 2.0
   * @description Delete search query.
   */
  "delete": function _delete(id) {
    return "/v2/clients/search-queries/" + id;
  }
};
var SearchQueriesEndpoints = _objectSpread(_objectSpread({}, SearchQueriesDynamic), SearchQueriesStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/clients/search-queries/search-queries.request.ts


function saveSearchQuery(body) {
  return (0,base_services_request/* postRequest */.j0)(SearchQueriesEndpoints.save, body).then(function (_ref) {
    var data = _ref.data;
    return data.data;
  });
}
function getSearchQueries() {
  return (0,base_services_request/* getRequest */.A_)(SearchQueriesEndpoints.list).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}
function deleteSearchQuery(id) {
  return (0,base_services_request/* deleteRequest */.Jl)(SearchQueriesEndpoints["delete"](id)).then(function (_ref3) {
    var data = _ref3.data;
    return data.data;
  });
}

/***/ }),

/***/ 30005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ proyectos_RealestateList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./custom-hooks/useWindowsSize.hook.js
var useWindowsSize_hook = __webpack_require__(51860);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/components/advance-filter-dialog/index.tsx + 13 modules
var advance_filter_dialog = __webpack_require__(4651);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox_Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel_FormControlLabel = __webpack_require__(50480);
;// CONCATENATED MODULE: ./shared/components/radio/DefaultRadio.tsx




var _excluded = (/* unused pure expression or super */ null && (["color", "label", "labelPlacement", "value", "className", "type"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var COLORS = {
  primary: {
    "--background-color": "#E92027"
  },
  secondary: {
    "--background-color": "#1f3564"
  }
};
var PADDING = {
  end: {
    "--padding": "2px 0 0 5px"
  },
  top: {
    "--padding": "0 0 5px 0"
  },
  start: {
    "--padding": "2px 5px 0 0"
  },
  bottom: {
    "--padding": "5px 0 0 0"
  }
};

function DefaultRadio(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? "primary" : _props$color,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? "start" : _props$labelPlacement,
      value = props.value,
      className = props.className,
      _props$type = props.type,
      type = _props$type === void 0 ? "radio" : _props$type,
      rest = _objectWithoutProperties(props, _excluded);

  var colors = COLORS[color];
  var padding = PADDING[labelPlacement];

  var styles = _objectSpread(_objectSpread({}, colors), padding);

  if (label) {
    return ___EmotionJSX(StyledLabel, {
      control: ___EmotionJSX(StyledRadio, _extends({
        value: value,
        type: type
      }, rest)),
      value: value,
      label: label,
      labelPlacement: labelPlacement,
      style: styles,
      className: className
    });
  }

  return ___EmotionJSX(StyledRadio, _extends({
    className: className,
    style: styles,
    type: type
  }, rest));
}

var StyledRadio = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "ejzrca1"
} : 0)( true ? {
  name: "5jefp0",
  styles: "width:20px;height:20px;background-color:#8c8c8c;border-radius:50%;vertical-align:middle;cursor:pointer;font-family:inherit;font-size:100%;line-height:1.15;margin:0;color:var(--colors);appearance:none;overflow:visible;&:checked{background-color:var(--background-color);}"
} : 0);

var StyledLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FormControlLabel_FormControlLabel/* default */.Z,  true ? {
  target: "ejzrca0"
} : 0)( true ? {
  name: "1ycl2m1",
  styles: "margin:0;padding:0;& .MuiFormControlLabel-label{font-size:inherit;line-height:inherit;font-family:inherit;font-weight:400;padding:var(--padding);color:var(--color-blue-main);}"
} : 0);

/* harmony default export */ var radio_DefaultRadio = ((/* unused pure expression or super */ null && (DefaultRadio)));
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/radio/RadioTabs.tsx



var RadioTabs_excluded = ["color", "children", "radioGroup", "onChange"],
    _excluded2 = ["color", "children", "id", "radioGroup", "className", "value", "onChange", "checked"];

function RadioTabs_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var TABSCOLOR = {
  "default": {
    "--tabs-color": "var(--color-blue-main)"
  }
};
var TABCOLOR = {
  primary: {
    "--tab-color": "var(--color-secondary)"
  }
};

function RadioTab(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? "primary" : _props$color,
      children = props.children,
      radioGroup = props.radioGroup,
      onChange = props.onChange,
      rest = (0,objectWithoutProperties/* default */.Z)(props, RadioTabs_excluded);

  var styles = TABCOLOR[color];
  var ChildrenWithProps = react.Children.map(children, function (child) {
    if ( /*#__PURE__*/react.isValidElement(child)) {
      var opt = {
        radioGroup: radioGroup,
        onChange: onChange
      };
      return /*#__PURE__*/react.cloneElement(child, opt);
    }

    return child;
  });
  return (0,emotion_react_browser_esm/* jsx */.tZ)(RadioTabSection, (0,esm_extends/* default */.Z)({}, rest, {
    style: styles
  }), ChildrenWithProps);
}

function RadioTabs(props) {
  var _props$color2 = props.color,
      color = _props$color2 === void 0 ? "default" : _props$color2,
      children = props.children,
      id = props.id,
      radioGroup = props.radioGroup,
      className = props.className,
      value = props.value,
      onChange = props.onChange,
      checked = props.checked,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);

  var styles = TABSCOLOR[color];
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, {
    className: className,
    style: styles
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(RadioTabsInput, (0,esm_extends/* default */.Z)({
    type: "radio",
    id: id,
    name: radioGroup,
    value: value,
    onChange: onChange,
    checked: checked
  }, rest)), (0,emotion_react_browser_esm/* jsx */.tZ)(RadioTabsLabel, {
    htmlFor: id
  }, children));
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h50wl33"
} : 0)( true ? {
  name: "5bw37x",
  styles: "display:inline;margin-right:-8px;&:last-of-type{margin-right:0;}"
} : 0);

var RadioTabSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1h50wl32"
} : 0)( true ? {
  name: "10r443q",
  styles: "width:max-content;min-width:min-content;border-radius:0 0 16px 16px;padding:0;background-color:transparent;height:fit-content"
} : 0);

var RadioTabsInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1h50wl31"
} : 0)( true ? {
  name: "1ia8468",
  styles: "display:none;box-sizing:border-box;padding:0;overflow:visible;font-family:inherit;font-size:100%;line-height:1.15;margin:0"
} : 0);

var RadioTabsLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("label",  true ? {
  target: "e1h50wl30"
} : 0)("padding:7px 19px 9px;display:inline-block;background-color:transparent;color:#fff;border-radius:0 0 16px 16px;position:relative;font-size:0.8rem;font-weight:500;min-width:150px;text-align:center;cursor:pointer;", RadioTabsInput, ":checked+&{background-color:var(--tabs-color);transform:scale(1.1);transition:0.2s;z-index:1;}", RadioTabsInput, ":not(:checked)+&{background-color:var(--tab-color);}" + ( true ? "" : 0));


;// CONCATENATED MODULE: ./shared/components/radio/index.tsx



// EXTERNAL MODULE: ./shared/components/buy-sell-filter/util/form.util.ts
var form_util = __webpack_require__(2553);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/base/PopperUnstyled/PopperUnstyled.js + 55 modules
var PopperUnstyled = __webpack_require__(62545);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
;// CONCATENATED MODULE: ./shared/components/tooltip/index.tsx





var tooltip_excluded = ["open", "children", "placement", "className", "onClose", "content", "arrow"];

function tooltip_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tooltip_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tooltip_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tooltip_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function tooltip_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function Tooltip(props) {
  var open = props.open,
      children = props.children,
      placement = props.placement,
      className = props.className,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
      content = props.content,
      arrow = props.arrow,
      rest = (0,objectWithoutProperties/* default */.Z)(props, tooltip_excluded);

  var anchorRef = (0,react.useRef)(null);

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, /*#__PURE__*/react.cloneElement(children, tooltip_objectSpread(tooltip_objectSpread({}, children.props), {}, {
    ref: anchorRef
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPopper, (0,esm_extends/* default */.Z)({
    open: open,
    anchorEl: anchorRef.current,
    placement: placement,
    className: className,
    modifiers: [{
      name: "preventOverflow",
      enabled: true,
      options: {
        rootBoundary: "window"
      }
    }, {
      name: "arrow",
      enabled: true,
      options: {
        element: arrowRef
      }
    }, {
      name: "offset",
      enabled: true,
      options: {
        offset: [0, 8]
      }
    }]
  }, rest), function (_ref) {
    var TransitionProps = _ref.TransitionProps;
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Fade/* default */.Z, (0,esm_extends/* default */.Z)({}, TransitionProps, {
      timeout: 350
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(ClickAwayListener/* default */.Z, {
      onClickAway: onClose
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(tooltip_Wrapper, {
      className: "wrapper-content"
    }, arrow && (0,emotion_react_browser_esm/* jsx */.tZ)(Arrow, {
      ref: setArrowRef
    }), content)));
  }));
}

/* harmony default export */ var tooltip = (Tooltip);

var Arrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e188i5dk2"
} : 0)( true ? {
  name: "6uu5v9",
  styles: "position:absolute;font-size:7px;width:38px;height:38px;&:before{content:\"\";margin:auto;display:block;width:0;height:0;border-style:solid;}"
} : 0);

var StyledPopper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(PopperUnstyled/* default */.Z,  true ? {
  target: "e188i5dk1"
} : 0)("z-index:1;&[data-popper-placement^=\"bottom\"] ", Arrow, "{top:0;left:0;margin-top:-16px;width:38px;height:30px;&:before{border-width:0 16px 16px 16px;border-color:transparent transparent #f2f2f2 transparent;}}" + ( true ? "" : 0));

var tooltip_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e188i5dk0"
} : 0)( true ? {
  name: "rbhwxd",
  styles: "padding:7px 26px;background-color:#f2f2f2;border-radius:12px;min-width:100px;box-shadow:0px 4px 4px rgba(0, 0, 0, 0.25)"
} : 0);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/Menu.tsx


function Menu_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function RadioContent(props) {
  var _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      name = props.name,
      onChange = props.onChange,
      value = props.value;
  return ___EmotionJSX(Menu_Wrapper, null, ___EmotionJSX(Options, null, ___EmotionJSX(StyledFormControl, null, ___EmotionJSX(RadioGroup, {
    name: name,
    value: value
  }, items.map(function (item, index) {
    return ___EmotionJSX(Menu_StyledLabel, {
      value: item.value,
      label: item.label,
      control: ___EmotionJSX(Menu_StyledRadio, {
        onClick: onChange,
        checked: value === item.value
      }),
      key: index
    });
  })))));
}
function CheckContent(props) {
  var _props$items2 = props.items,
      items = _props$items2 === void 0 ? [] : _props$items2,
      name = props.name,
      onChange = props.onChange,
      value = props.value;
  return ___EmotionJSX(Menu_Wrapper, null, ___EmotionJSX(Options, null, ___EmotionJSX(StyledFormControl, null, ___EmotionJSX(FormGroup, null, items.map(function (item, index) {
    return ___EmotionJSX(FormControlLabel, {
      key: index,
      control: ___EmotionJSX(Checkbox, {
        onClick: onChange,
        checked: value === item.value
      }),
      name: name,
      value: item.value,
      label: item.label
    });
  })))));
}

function Menu(props) {
  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var Children = /*#__PURE__*/react.cloneElement(props.children);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledTooltip, {
    onClose: handleClose,
    content: props.content,
    open: open
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    onClick: handleOpen
  }, Children)));
}

/* harmony default export */ var proyectos_Menu = (Menu);

var StyledTooltip = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(tooltip,  true ? {
  target: "e11v4utx5"
} : 0)( true ? {
  name: "vxdyyj",
  styles: "& .wrapper-content{padding:0;}"
} : 0);

var Menu_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11v4utx4"
} : 0)( true ? {
  name: "69ro02",
  styles: "background-color:#f7f6f4;border-radius:10px;padding:18px 13px 13px;min-width:190px"
} : 0);

var Options = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11v4utx3"
} : 0)( true ? {
  name: "oqo80w",
  styles: "width:100%;display:block;overflow:auto;max-height:200px"
} : 0);

var StyledFormControl = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FormControl/* default */.Z,  true ? {
  target: "e11v4utx2"
} : 0)( true ? {
  name: "6og82r",
  styles: "margin-left:0px"
} : 0);

var Menu_StyledRadio = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Radio/* default */.Z,  true ? {
  target: "e11v4utx1"
} : 0)( true ? {
  name: "1btselr",
  styles: "padding:5px;color:#1f3564;&.Mui-checked{color:#4caf50;}& svg{width:20px;height:20px;}"
} : 0);

var Menu_StyledLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FormControlLabel_FormControlLabel/* default */.Z,  true ? {
  target: "e11v4utx0"
} : 0)( true ? {
  name: "b1cywf",
  styles: "margin-left:0;& .MuiFormControlLabel-label{font-family:var(--font-family);color:var(--color-blue-main);font-weight:600;font-size:var(--fs-body-small);vertical-align:bottom!important;line-height:1.5;}"
} : 0);
// EXTERNAL MODULE: ./shared/models/const/currencyTypes.ts
var currencyTypes = __webpack_require__(83479);
// EXTERNAL MODULE: ./shared/components/label-field/index.tsx
var label_field = __webpack_require__(78836);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./shared/components/switch-labels/default-switch-labels.tsx
var default_switch_labels = __webpack_require__(58169);
// EXTERNAL MODULE: ./shared/components/switch-labels/formik-switch-labels.tsx
var formik_switch_labels = __webpack_require__(16447);
;// CONCATENATED MODULE: ./shared/components/switch-labels/index.tsx



// EXTERNAL MODULE: ./shared/components/text-field/index.tsx + 2 modules
var text_field = __webpack_require__(22900);
// EXTERNAL MODULE: ./shared/components/mask-components/index.tsx + 1 modules
var mask_components = __webpack_require__(6107);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button_Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/PriceRangeFilter.tsx



var PriceRangeFilter_excluded = ["children"];

function PriceRangeFilter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PriceRangeFilter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PriceRangeFilter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PriceRangeFilter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PriceRangeFilter_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













function PriceRangeFilters(props) {
  var children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, PriceRangeFilter_excluded);

  var Children = /*#__PURE__*/react.cloneElement(children);
  var Content = /*#__PURE__*/react.createElement(PriceComponent, PriceRangeFilter_objectSpread({}, rest));
  return (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_Menu, {
    content: Content
  }, Children);
}

var PriceComponent = function PriceComponent(props) {
  var translations = (0,next_intl_cjs_production_min.useTranslations)("formRealestateFilters");
  var onChange = props.onChange,
      valueCurrencyType = props.valueCurrencyType,
      valuePrice = props.valuePrice,
      onChangePrice = props.onChangePrice;
  var debouncedChangePrice = (0,react.useMemo)(function () {
    return (0,lodash.debounce)(onChangePrice, 500);
  }, [onChangePrice]);

  var _useState = (0,react.useState)(valuePrice[0]),
      min = _useState[0],
      setMin = _useState[1];

  var _useState2 = (0,react.useState)(valuePrice[1]),
      max = _useState2[0],
      setMax = _useState2[1];

  var _useState3 = (0,react.useState)(valueCurrencyType),
      current = _useState3[0],
      setCurrent = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      error = _useState4[0],
      setError = _useState4[1];

  (0,react.useEffect)(function () {
    if (+max && +max < +min) {
      setError(translations("price_range-error_message"));
      return;
    }

    setError("");
  }, [min, max]);

  var SubmitChanges = function SubmitChanges(e) {
    e.preventDefault();
    onChangePrice([min, max, current]); // onChange();
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(PriceRangeFilter_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    sx: {
      paddingY: 2
    },
    alignItems: "center",
    spacing: 1,
    justifyContent: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    item: true,
    xs: 12,
    spacing: 1,
    alignItems: "center",
    justifyContent: "space-between"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(label_field/* default */.Z, {
    label: "Precio"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(default_switch_labels/* default */.Z, {
    onChange: function onChange(e) {
      setCurrent(e);
      setMin("");
      setMax("");
    },
    value: current,
    options: currencyTypes/* CCurrencyTypes */.v
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    container: true,
    spacing: 1,
    marginY: 3
  }, error ? (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ErrorMessage, null, error)) : null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 6
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* DefaultTextField */.k, {
    placeholder: translations("minimum"),
    inputComponent: mask_components/* MoneyInput */.PK,
    name: "amountMin",
    value: min,
    onChange: function onChange(e) {
      setMin(e);
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 6
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(text_field/* DefaultTextField */.k, {
    inputComponent: mask_components/* MoneyInput */.PK,
    placeholder: translations("maximum"),
    name: "amountMax",
    value: max,
    onChange: function onChange(e) {
      setMax(e);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        SubmitChanges(e);
      }
    }
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    xs: 12,
    justifyContent: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomButton, {
    variant: "contained",
    onClick: SubmitChanges
  }, translations("btnApplyPrice"))))));
};

var PriceRangeFilter_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exxmp0t2"
} : 0)( true ? {
  name: "1otrsk2",
  styles: "background-color:#f7f6f4;border-radius:10px;padding:18px 13px 13px;max-width:380px"
} : 0);

var CustomButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button_Button/* default */.Z,  true ? {
  target: "exxmp0t1"
} : 0)( true ? {
  name: "1u08ufx",
  styles: "border-radius:20px;font-size:13px;min-width:120px;text-transform:capitalize;font-weight:600"
} : 0);

var ErrorMessage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "exxmp0t0"
} : 0)( true ? {
  name: "1i9ngxc",
  styles: "color:var(--color-red-error)"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormGroup/FormGroup.js + 1 modules
var FormGroup_FormGroup = __webpack_require__(53457);
// EXTERNAL MODULE: ./shared/components/checkBox/index.tsx
var checkBox = __webpack_require__(90443);
;// CONCATENATED MODULE: ./shared/components/checbox-group/DefaultGroup.tsx


var DefaultGroup_excluded = ["values", "items", "columns", "className", "manualChecked", "handleCheckedStatusCustom"];

function DefaultGroup_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var _ref =  true ? {
  name: "m8xxed",
  styles: "width:100%;& .MuiFormControlLabel-label{font-family:var(--font-family);color:var(--color-blue-main);font-weight:600;font-size:var( --fs-body-small);vertical-align:bottom !important;}"
} : 0;

function DefaultGroup_DefaultGroup(props) {
  var _props$values = props.values,
      values = _props$values === void 0 ? [] : _props$values,
      items = props.items,
      columns = props.columns,
      className = props.className,
      _props$manualChecked = props.manualChecked,
      manualChecked = _props$manualChecked === void 0 ? true : _props$manualChecked,
      handleCheckedStatusCustom = props.handleCheckedStatusCustom,
      rest = (0,objectWithoutProperties/* default */.Z)(props, DefaultGroup_excluded);

  var styles = {
    root: _ref
  };

  var handleCustomCheck = function handleCustomCheck(item) {
    if (props !== null && props !== void 0 && props.handleCheckedStatusCustom) {
      return props === null || props === void 0 ? void 0 : props.handleCheckedStatusCustom(item.value);
    } else {
      return handleCheckedStatus(item.value);
    }
  };

  var handleCheckedStatus = function handleCheckedStatus(value) {
    var finalValue = value;

    if (typeof value === "number") {
      finalValue = finalValue.toString();
    } // @ts-ignore


    var itemsArray = values[props.name] || [];
    return itemsArray.includes(finalValue);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(FormGroup_FormGroup/* default */.Z, {
    row: props.row,
    css: styles.root,
    className: className
  }, props.items.map(function (item, i) {
    var _props$columns, _item$disable, _item$checked;

    return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: (_props$columns = props.columns) !== null && _props$columns !== void 0 ? _props$columns : 6,
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(FormControlLabel_FormControlLabel/* default */.Z, (0,esm_extends/* default */.Z)({
      disabled: (_item$disable = item === null || item === void 0 ? void 0 : item.disable) !== null && _item$disable !== void 0 ? _item$disable : false,
      checked: (_item$checked = item === null || item === void 0 ? void 0 : item.checked) !== null && _item$checked !== void 0 ? _item$checked : false,
      control: manualChecked ? (0,emotion_react_browser_esm/* jsx */.tZ)(checkBox/* default */.Z, {
        checked: handleCustomCheck(item)
      }) : (0,emotion_react_browser_esm/* jsx */.tZ)(checkBox/* default */.Z, null)
    }, rest, {
      label: item.label,
      value: item.value
    })));
  }));
} //


/* harmony default export */ var checbox_group_DefaultGroup = (DefaultGroup_DefaultGroup);
;// CONCATENATED MODULE: ./shared/components/checbox-group/FormikGroup.tsx








function FormikGroup(props) {
  var _useField = useField(props),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values;

  return ___EmotionJSX(DefaultGroup, _extends({}, props, {
    values: values
  }, field));
}

/* harmony default export */ var checbox_group_FormikGroup = ((/* unused pure expression or super */ null && (FormikGroup)));
;// CONCATENATED MODULE: ./shared/components/checbox-group/index.tsx



;// CONCATENATED MODULE: ./shared/components-pages/proyectos/RoomFilters.tsx


var RoomFilters_excluded = ["children"];

function RoomFilters_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function Content(props) {
  var onChange = props.onChange,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("realestateList.bedroomsFilters");
  var roomOptions = [{
    label: translation("oneBedroom"),
    value: "1"
  }, {
    label: translation("twoBedroom"),
    value: "2"
  }, {
    label: translation("threeBedroom"),
    value: "3"
  }, {
    label: translation("fourBedroom"),
    value: "4"
  }, {
    label: translation("more"),
    value: ">4"
  }];

  var handleCheckedStatus = function handleCheckedStatus(item) {
    return value.includes(item);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(RoomFilters_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(RoomFilters_Options, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledGroup, {
    manualChecked: true,
    handleCheckedStatusCustom: handleCheckedStatus,
    columns: 12,
    items: roomOptions,
    row: false,
    onChange: onChange,
    values: value,
    name: "bedrooms"
  })));
}

function RoomFilters(props) {
  var children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, RoomFilters_excluded);

  var Children = /*#__PURE__*/react.cloneElement(props.children);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_Menu, {
    content: (0,emotion_react_browser_esm/* jsx */.tZ)(Content, rest)
  }, Children);
}

/* harmony default export */ var proyectos_RoomFilters = (RoomFilters);

var RoomFilters_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el2uubd2"
} : 0)( true ? {
  name: "2weppb",
  styles: "background-color:#f7f6f4;border-radius:10px;padding:18px 13px 13px"
} : 0);

var RoomFilters_Options = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el2uubd1"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var StyledGroup = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(checbox_group_DefaultGroup,  true ? {
  target: "el2uubd0"
} : 0)( true ? {
  name: "6calca",
  styles: "& .MuiFormControlLabel-root{margin-left:0;}& .MuiCheckbox-root{padding:5px;color:#1f3564;}& .MuiSvgIcon-root{width:20px;height:20px;}"
} : 0);
// EXTERNAL MODULE: ./custom-hooks/useGetPersintParamas.hook.ts
var useGetPersintParamas_hook = __webpack_require__(53541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./api/realestate.request.ts + 1 modules
var realestate_request = __webpack_require__(13897);
// EXTERNAL MODULE: ./shared/components/message-modal/index.tsx
var message_modal = __webpack_require__(36481);
// EXTERNAL MODULE: ./shared/components/auto-complete-field/index.tsx + 2 modules
var auto_complete_field = __webpack_require__(69891);
// EXTERNAL MODULE: ./custom-hooks/use-cities.hook.ts + 2 modules
var use_cities_hook = __webpack_require__(78647);
// EXTERNAL MODULE: ./shared/models/functions/cities.helper.ts
var cities_helper = __webpack_require__(75769);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/SearchBar.tsx



var SearchBar_excluded = ["description"];

function SearchBar_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















function SearchBar(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      onChange = props.onChange,
      collection = props.collection;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("realestateList");
  var translationNotFound = (0,next_intl_cjs_production_min.useTranslations)("realestateList.notFound");

  var _useState = (0,react.useState)(""),
      search = _useState[0],
      onSearch = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var placeholder = (value === null || value === void 0 ? void 0 : value.length) > 0 ? "" : translation("searchPlaceholder");
  var width = (0,use_width_hook/* useWidth */.z)();
  var router = (0,next_router.useRouter)();
  var refer = (0,useGetPersintParamas_hook/* default */.Z)({
    useConque: ""
  });

  var _useCities = (0,use_cities_hook/* default */.Z)({
    q: search
  }),
      isLoading = _useCities.isLoading,
      cities = _useCities.data;

  var handleSearch = function handleSearch(e) {
    if (e !== null && e !== void 0 && e.target) {
      onSearch(e.target.value);
    }
  };

  var handleToggleModal = function handleToggleModal() {
    setOpen(!open);
  };

  var onSubmit = function onSubmit() {
    var realestateId = parseInt(search);
    var redirect = collection ? pages_path/* CPagesPath.es.collection_property_detail */.K.es.collection_property_detail : pages_path/* CPagesPath.es.property_detail */.K.es.property_detail;

    if (Boolean(realestateId)) {
      (0,realestate_request/* getRealestateDetails */.mW)(realestateId).then(function (r) {
        router.push({
          pathname: redirect(r.data),
          query: refer
        });
      })["catch"](function () {
        return handleToggleModal();
      });
    }
  };

  var handleLocationChange = function handleLocationChange(e, newValue) {
    // if enter was pressed
    if (e.keyCode === 13 && Boolean(parseInt(search))) {
      onSubmit();
    } else {
      if (onChange) {
        if (newValue.length == 2) {
          onChange(e, [newValue[1]]);
          return;
        }

        onChange(e, newValue);
      }
    }
  };

  var items = cities ? (0,cities_helper/* default */.Z)(cities) : [];
  return (0,emotion_react_browser_esm/* jsx */.tZ)(SearchBar_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CoverAutoComplete, {
    value: value,
    id: "locations",
    name: "locations",
    multiple: true,
    loading: isLoading,
    placeholder: placeholder,
    onInputChange: lodash_default().debounce(handleSearch, 500),
    className: "city-autocomplete",
    onChange: handleLocationChange,
    freeSolo: Boolean(parseInt(search)),
    options: items,
    getOptionLabel: function getOptionLabel(option) {
      return option === null || option === void 0 ? void 0 : option.description;
    },
    limitTags: ["xs", "sm"].includes(width) ? 1 : 3,
    renderOption: function renderOption(props, option) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(ItemElementLabel, (0,esm_extends/* default */.Z)({}, props, option));
    },
    noOptionsText: !((search === null || search === void 0 ? void 0 : search.length) > 2) ? translation("searchHelp") : translation("searchHelpSD")
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(SubmitButton, {
    bg: "--color-blue-main",
    onClick: onSubmit
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Image, {
    src: "/icons/loupe_remax_rd.svg",
    alt: "Loupe icon"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(message_modal/* ModalMessage */.P, {
    title: translationNotFound("title"),
    body: translationNotFound("body"),
    variant: "error",
    open: open,
    handleClose: handleToggleModal
  }));
}

/* harmony default export */ var proyectos_SearchBar = (SearchBar);

var ItemElementLabel = function ItemElementLabel(props) {
  var description = props.description,
      rest = (0,objectWithoutProperties/* default */.Z)(props, SearchBar_excluded);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Item, rest, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "noWrap isCity"
  }, description));
};

var SearchBar_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evjl0ug4"
} : 0)( true ? {
  name: "1n0yaxa",
  styles: "width:100%;position:relative;@media screen and (max-width: 450px){margin-top:10px;}"
} : 0);

var SubmitButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "evjl0ug3"
} : 0)( true ? {
  name: "16cyzpb",
  styles: "position:absolute;top:0;right:0;padding:10px 15px;border-radius:15px"
} : 0);

var Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "evjl0ug2"
} : 0)( true ? {
  name: "1aynuae",
  styles: "width:20px;height:20px"
} : 0);

var CoverAutoComplete = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(auto_complete_field/* AutoCompleteField */.K,  true ? {
  target: "evjl0ug1"
} : 0)( true ? {
  name: "1d29o69",
  styles: "width:100%;border:none;outline:none;padding:0px;& fieldset{border:none;}& .MuiInputBase-fullWidth.MuiInputBase-root{flex-wrap:nowrap;&.Mui-focused{flex-wrap:wrap;}}& .MuiInputBase-root{background-color:#f7f6f4;border-radius:15px;padding:0;border:1px solid #d0d0d0;&.Mui-focused{border-radius:15px;}}& .MuiAutocomplete-tag{background-color:var(--color-blue-main);color:white;font-weight:500;}& .MuiChip-deleteIcon{color:white!important;}& span.MuiAutocomplete-tagSizeMedium{border-radius:100%;width:20px;height:20px;font-size:10px;display:flex;justify-content:center;align-items:center;}& .Mui-focused .MuiAutocomplete-tag{max-width:calc(100% - 40px);}& .city-autocomplete{width:100%;}"
} : 0);

var Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "evjl0ug0"
} : 0)( true ? {
  name: "ox510f",
  styles: "width:100%;display:flex;&.MuiAutocomplete-option.Mui-focused{background-color:transparent;&:hover span{color:white;}}.noWrap{white-space:nowrap;}& span{color:var(--color-blue-main);font-weight:bold;margin-right:5px;}& .isCity,.isSector{color:var(--color-blue-main);}& .description{color:#989694;line-height:20px;}@media screen and (max-width: 450px){flex-direction:column;align-items:start;white-space:nowrap;text-align:left;font-size:13px;& .isCity{width:100%;}& .description{text-align:left;font-weight:400;width:100%;}}"
} : 0);
// EXTERNAL MODULE: ./shared/models/functions/query-string-helper.ts
var query_string_helper = __webpack_require__(23622);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./api/sector.request.ts + 1 modules
var sector_request = __webpack_require__(14788);
;// CONCATENATED MODULE: ./custom-hooks/use-sector.hook.ts



var useSectors = function useSectors(_ref) {
  var idCity = _ref.idCity,
      _onSuccess = _ref.onSuccess;

  var _useQuery = (0,useQuery/* useQuery */.a)(["list-sectors", idCity], function () {
    return (0,sector_request/* getSector */.s)({
      cityId: idCity
    });
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!idCity,
    onSuccess: function onSuccess(_ref2) {
      var data = _ref2.data;
      return _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess(data);
    }
  }),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading;

  return {
    data: data,
    isLoading: isLoading
  };
};

/* harmony default export */ var use_sector_hook = (useSectors);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/SectorFilters.tsx


var SectorFilters_excluded = ["children"];

function SectorFilters_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function SectorFilters_Content(props) {
  var _onChange = props.onChange,
      value = props.value,
      sectorsCheckedList = props.sectorsCheckedList,
      queryFilters = props.queryFilters;
  var router = (0,next_router.useRouter)();
  var filters = (0,query_string_helper/* queryParserUrl */.HL)(router.asPath);
  var idCity = getIdCity(filters, queryFilters);

  var _useState = (0,react.useState)([]),
      sectorList = _useState[0],
      setSectorList = _useState[1];

  var _useState2 = (0,react.useState)([]),
      checkedList = _useState2[0],
      setCheckedList = _useState2[1];

  var translations = (0,next_intl_cjs_production_min.useTranslations)("realestateList");

  var _useSectors = use_sector_hook({
    idCity: idCity,
    onSuccess: function onSuccess(data) {
      return ParseSectors(data);
    }
  }),
      data = _useSectors.data,
      isLoading = _useSectors.isLoading;

  var filterSectors = (0,react.useCallback)(function (search) {
    if (!(data !== null && data !== void 0 && data.data)) return;
    var sectors = data.data;

    if (!!search) {
      sectors = data.data.filter(function (x) {
        return x.description.toLowerCase().includes(search.toLowerCase());
      });
    }

    ParseSectors(sectors);
  }, [data]);
  (0,react.useEffect)(function () {
    if (data !== null && data !== void 0 && data.data) ParseSectors(data.data);
  }, []);
  var ParseSectors = (0,react.useCallback)(function (sectors) {
    var collator = new Intl.Collator("es", {
      sensitivity: "base"
    });
    setSectorList(sectors.filter(function (x) {
      return x;
    }).map(function (sector) {
      var _queryFilters$sectorN;

      return {
        value: sector === null || sector === void 0 ? void 0 : sector.id,
        label: sector === null || sector === void 0 ? void 0 : sector.description,
        id: sector === null || sector === void 0 ? void 0 : sector.id,
        checked: checkedList.find(function (checked) {
          return (checked === null || checked === void 0 ? void 0 : checked.id) == (sector === null || sector === void 0 ? void 0 : sector.id) || (checked === null || checked === void 0 ? void 0 : checked.value) == (sector === null || sector === void 0 ? void 0 : sector.id);
        }) || collator.compare(sector.description, (_queryFilters$sectorN = queryFilters.sectorName) === null || _queryFilters$sectorN === void 0 ? void 0 : _queryFilters$sectorN.replaceAll("-", " ")) == 0
      };
    }));
  }, []);
  (0,react.useEffect)(function () {
    setCheckedList(sectorsCheckedList);
  }, [sectorsCheckedList]);

  if (!(data !== null && data !== void 0 && data.data) && !idCity) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SectorFilters_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(MessageResults, null, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
      href: "#locations",
      className: "aqu\xED_sector"
    }, translations("sectorFilter.text1"), "\xA0", (0,emotion_react_browser_esm/* jsx */.tZ)(LinkStyle, null, translations("sectorFilter.text2")))));
  }

  if (isLoading || !(data !== null && data !== void 0 && data.data)) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SectorFilters_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(MessageResults, null, "Cargando"));
  }

  var handleCheckedStatus = function handleCheckedStatus(item) {
    if (Array.isArray(value)) {
      return value.filter(function (x) {
        return x;
      }).find(function (l) {
        return (l === null || l === void 0 ? void 0 : l.id) == item;
      });
    }

    return undefined;
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(SectorFilters_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(SectorFilters_Options, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentSearch, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomDefaultTextField, {
    placeholder: "Buscar ...",
    name: "search",
    onChange: function onChange(e) {
      return filterSectors(e.target.value);
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(SectorFilters_StyledGroup, {
    manualChecked: true,
    handleCheckedStatusCustom: handleCheckedStatus,
    columns: 12,
    items: sectorList,
    row: false,
    onChange: function onChange(e) {
      return _onChange(e, data === null || data === void 0 ? void 0 : data.data);
    },
    values: value,
    name: "sector"
  })));
}

function SectorFilters(props) {
  var children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, SectorFilters_excluded);

  var Children = /*#__PURE__*/react.cloneElement(props.children);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_Menu, {
    content: (0,emotion_react_browser_esm/* jsx */.tZ)(SectorFilters_Content, rest)
  }, Children);
}

/* harmony default export */ var proyectos_SectorFilters = (SectorFilters);

var ContentSearch = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezw5wbn6"
} : 0)( true ? {
  name: "1y56qe4",
  styles: "position:sticky;top:0;left:0;background-color:#f7f6f4;padding:10px 5px;z-index:1000"
} : 0);

var CustomDefaultTextField = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(text_field/* DefaultTextField */.k,  true ? {
  target: "ezw5wbn5"
} : 0)( true ? {
  name: "58skxc",
  styles: "&.MuiInput-root{padding:5px 23px!important;}"
} : 0);

var MessageResults = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ezw5wbn4"
} : 0)( true ? {
  name: "uegnrb",
  styles: "color:var(--color-blue-main);font-weight:700;font-size:13px;text-align:center;width:100%;display:inline-block"
} : 0);

var LinkStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ezw5wbn3"
} : 0)( true ? {
  name: "c75fzx",
  styles: "color:var(--color-secondary);text-decoration:underline"
} : 0);

var SectorFilters_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezw5wbn2"
} : 0)( true ? {
  name: "71ukh5",
  styles: "background-color:#f7f6f4;border-radius:10px;padding:18px 13px 13px;min-width:200px"
} : 0);

var SectorFilters_Options = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezw5wbn1"
} : 0)( true ? {
  name: "oqo80w",
  styles: "width:100%;display:block;overflow:auto;max-height:200px"
} : 0);

var SectorFilters_StyledGroup = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(checbox_group_DefaultGroup,  true ? {
  target: "ezw5wbn0"
} : 0)( true ? {
  name: "6calca",
  styles: "& .MuiFormControlLabel-root{margin-left:0;}& .MuiCheckbox-root{padding:5px;color:#1f3564;}& .MuiSvgIcon-root{width:20px;height:20px;}"
} : 0);

var getIdCity = function getIdCity(filters, queryFilters) {
  var _filters$query, _queryFilters$locatio;

  if ((_filters$query = filters.query) !== null && _filters$query !== void 0 && _filters$query.locations) {
    var _filters$query2;

    return (_filters$query2 = filters.query) === null || _filters$query2 === void 0 ? void 0 : _filters$query2.locations[0].split("&")[0].split("-")[1];
  } else if (queryFilters !== null && queryFilters !== void 0 && (_queryFilters$locatio = queryFilters.locations[0]) !== null && _queryFilters$locatio !== void 0 && _queryFilters$locatio.id) {
    return queryFilters === null || queryFilters === void 0 ? void 0 : queryFilters.locations[0].id;
  }

  return null;
};
// EXTERNAL MODULE: ./shared/models/const/property-types.ts
var property_types = __webpack_require__(86465);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/TypeFilters.tsx


var TypeFilters_excluded = ["children"];

function TypeFilters_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function TypeFilters_Content(props) {
  var onTypeChange = props.onTypeChange,
      _props$typeProperty = props.typeProperty,
      typeProperty = _props$typeProperty === void 0 ? [] : _props$typeProperty,
      collection = props.collection;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("realestateList.typeFilters");
  var values = {
    typeProperty: typeProperty
  };
  var propertyTypes = (0,property_types/* useIntlPropertyTypes */.Pb)().map(function (item) {
    return {
      label: item.name,
      value: item.slug
    };
  });
  var collectionProperties = [translation("house"), translation("apartment"), translation("tourist"), translation("penthouse"), translation("project")];
  var collectionTypes = propertyTypes.filter(function (e) {
    return collectionProperties.includes(e.label);
  });
  var items = collection ? collectionTypes : propertyTypes;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(TypeFilters_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(TypeFilters_Options, null, (0,emotion_react_browser_esm/* jsx */.tZ)(TypeFilters_StyledGroup, {
    columns: 12,
    items: items,
    row: false,
    onChange: onTypeChange,
    values: values,
    name: "typeProperty"
  })));
}

function TypeFilters(props) {
  var children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, TypeFilters_excluded);

  var Children = /*#__PURE__*/react.cloneElement(props.children);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_Menu, {
    content: (0,emotion_react_browser_esm/* jsx */.tZ)(TypeFilters_Content, rest)
  }, Children);
}

/* harmony default export */ var proyectos_TypeFilters = (TypeFilters);

var TypeFilters_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1sb3myu2"
} : 0)( true ? {
  name: "2weppb",
  styles: "background-color:#f7f6f4;border-radius:10px;padding:18px 13px 13px"
} : 0);

var TypeFilters_Options = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1sb3myu1"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var TypeFilters_StyledGroup = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(checbox_group_DefaultGroup,  true ? {
  target: "e1sb3myu0"
} : 0)( true ? {
  name: "6calca",
  styles: "& .MuiFormControlLabel-root{margin-left:0;}& .MuiCheckbox-root{padding:5px;color:#1f3564;}& .MuiSvgIcon-root{width:20px;height:20px;}"
} : 0);
// EXTERNAL MODULE: ./shared/context/news.context.tsx
var news_context = __webpack_require__(30995);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/Filters.tsx



var Filters_excluded = ["label", "icon", "component", "id"];

function Filters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Filters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Filters_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Filters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Filters_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















 // import AdvancedFilters from "./AdvanceFilters";



function CustomLabel(props) {
  var active = props.active,
      label = props.label,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(LabelWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledCheckbox, {
    checked: active,
    onClick: onChange
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Label, null, label));
}

function Filters(props) {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("realestateList");

  var _useShowNews = (0,news_context/* useShowNews */.H)(),
      showNews = _useShowNews.showNews;

  var _props$filters = props.filters,
      filters = _props$filters === void 0 ? form_util/* FormConfig.initialValues */.Z.initialValues : _props$filters,
      onBusinessChange = props.onBusinessChange,
      onTypeChange = props.onTypeChange,
      onBedroomsChange = props.onBedroomsChange,
      handleAdvancedFilters = props.handleAdvancedFilters,
      onLocationsChange = props.onLocationsChange,
      collection = props.collection,
      onSectorsChange = props.onSectorsChange,
      onCurrencyChange = props.onCurrencyChange,
      onAmountChange = props.onAmountChange;
  var width = (0,use_width_hook/* useWidth */.z)();
  var isMobile = ["xs", "sm"].includes(width);
  var size = (0,useWindowsSize_hook/* default */.Z)();
  var filtersOptions = [{
    label: translation("type"),
    icon: "/icons/icon_house_remaxrd.svg",
    component: proyectos_TypeFilters,
    onTypeChange: onTypeChange,
    typeProperty: filters.typeProperty,
    value: filters.typeProperty,
    collection: collection,
    id: "filterType"
  }, {
    label: "Sector",
    icon: "/icons/location.svg",
    component: proyectos_SectorFilters,
    onChange: onSectorsChange,
    value: filters.sector,
    id: "filterSector"
  }, {
    label: translation("bedrooms"),
    icon: "/icons/icon_bed_remaxrd_white.svg",
    component: proyectos_RoomFilters,
    onChange: onBedroomsChange,
    value: filters.bedrooms,
    id: "filterBedrooms"
  }, {
    label: translation("prices"),
    icon: "/icons/currency.svg",
    component: PriceRangeFilters,
    onChange: onCurrencyChange,
    valueCurrencyType: filters.currencyType,
    onChangePrice: onAmountChange,
    valuePrice: [filters.amountMin, filters.amountMax],
    id: "filterPrice"
  } // {
  //   label: translation("baths"),
  //   icon: "/icons/icon_bathtub_remaxrd_white.svg",
  //   component: BathtubFilters,
  //   onChange: onBathroomsChange,
  //   value: filters.bathrooms,
  // },
  // {
  //   label: translation("parkings"),
  //   icon: "/icons/icon_car_remaxrd_white.svg",
  //   component: ParkingLotsFilters,
  //   onChange: onParkingLotsChange,
  //   value: filters.parkings,
  // },
  ];

  var advancedFiltersSubmit = function advancedFiltersSubmit(values) {
    handleAdvancedFilters(values);
  };

  var handleCheckedState = function handleCheckedState(value) {
    return filters.businessTypes === value;
  };

  var countAdvancedFilters = function countAdvancedFilters(filters) {
    var desktopIgnoredFilters = ["city", "locations", "page", "businessTypes", "typeProperty", "bedrooms", "collection", "referer", "areferer", "currencyType", "amountMax", "amountMin", "orderBy", "sector", "recent"];
    var mobileIgnoredFilters = [// "city",
    // "sector",
    // "locations",
    "page", "collection", "referer", "areferer", "currencyType", "orderBy", "recent"];
    var width = size === null || size === void 0 ? void 0 : size.width;
    var ignoredFilters = width > 991 ? desktopIgnoredFilters : mobileIgnoredFilters;
    var counter = 0;
    Object.keys(filters).forEach(function (key) {
      if (!ignoredFilters.includes(key) && !isNull(filters[key])) {
        counter++;
      }
    });
    return counter;
  };

  var isNull = function isNull(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    }

    if (value) {
      return false;
    }

    return true;
  };

  var countFilters = function countFilters(value) {
    if (Array.isArray(value)) {
      return value.length;
    } else if (value) {
      return value === ">4" ? "4+" : value;
    }

    return 0;
  };

  var onCustomLabelChange = function onCustomLabelChange() {
    var value = filters.businessTypes == "sale" ? "lease" : "sale";
    onBusinessChange(value);
  };

  var filtersCount = countAdvancedFilters(filters);

  var handleReset = function handleReset(values) {
    advancedFiltersSubmit(form_util/* FormConfig.initialValues */.Z.initialValues);
  };

  var ConfigForm = {
    initialValues: filters,
    onSubmit: advancedFiltersSubmit,
    enableReinitialize: true
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Section, {
    collection: collection,
    showNews: showNews
  }, !isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(SearchWrapper, {
    width: size.width,
    collection: collection,
    showNews: showNews
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Search, null, (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_SearchBar, {
    value: filters.locations,
    onChange: onLocationsChange,
    collection: collection
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Filters_Wrapper, {
    collection: collection
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(FlexWrapper, null, !isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(StyledRadioTab, {
    radioGroup: "businessTypes",
    onChange: onBusinessChange
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Filters_StyledRadio, {
    id: "sale",
    value: "sale",
    checked: handleCheckedState("sale")
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomLabel, {
    label: translation("sale"),
    active: filters.businessTypes == "sale",
    onChange: onCustomLabelChange
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Filters_StyledRadio, {
    id: "lease",
    value: "lease",
    checked: handleCheckedState("lease")
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomLabel, {
    label: translation("lease"),
    active: filters.businessTypes == "lease",
    onChange: onCustomLabelChange
  }))), !isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(OptionsWrapper, null, filtersOptions.map(function (item, index) {
    var label = item.label,
        icon = item.icon,
        component = item.component,
        id = item.id,
        rest = (0,objectWithoutProperties/* default */.Z)(item, Filters_excluded);

    var count = countFilters(rest.value);

    var Children = (0,emotion_react_browser_esm/* jsx */.tZ)(FilterWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(FilterOptions, {
      bg: "--color-blue-main",
      key: label + id,
      id: id
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(OptionsImg, {
      src: icon
    }), label), Boolean(count) && (0,emotion_react_browser_esm/* jsx */.tZ)(Badge, {
      style: {
        backgroundColor: "#e62f34"
      }
    }, count));

    return /*#__PURE__*/react.createElement(component, Filters_objectSpread(Filters_objectSpread({}, rest), {}, {
      sectorsCheckedList: label == "Sector" ? filters === null || filters === void 0 ? void 0 : filters.sector : [],
      queryFilters: props.filters
    }), Children);
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogForm, {
    ConfigForm: ConfigForm,
    filtersCount: filtersCount,
    translation: translation,
    handleReset: handleReset
  }))));
}

var DialogForm = function DialogForm(props) {
  var ConfigForm = props.ConfigForm,
      filtersCount = props.filtersCount,
      translation = props.translation,
      _handleReset = props.handleReset;
  var width = (0,use_width_hook/* useWidth */.z)();
  var isMobile = ["xs", "sm"].includes(width);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Formik */.J9, ConfigForm, function (pf) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Form */.l0, null, (0,emotion_react_browser_esm/* jsx */.tZ)(advance_filter_dialog/* default */.Z, {
      handleSubmit: function handleSubmit() {
        return pf.handleSubmit();
      },
      handleReset: function handleReset() {
        _handleReset();
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(AdvancedFilter, {
      id: "modal-propertyList"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(FilterImg, {
      src: "/icons/filter_remax_rd.svg",
      alt: "Filter icon"
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(FilterText, null, filtersCount && isMobile ? "EDITAR FILTROS" : translation("filters")), filtersCount > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(Badge, null, filtersCount))));
  });
};

var Filters_StyledRadio = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RadioTabs,  true ? {
  target: "eymc6r319"
} : 0)( true ? {
  name: "icbods",
  styles: "&>label{margin-top:2px;padding-top:14px;padding-bottom:13px;}"
} : 0);

var Search = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r318"
} : 0)( true ? {
  name: "qbeqej",
  styles: "width:100%;@media screen and (max-width: 1420px){width:650px;}@media screen and (max-width: 991px){width:100%;}"
} : 0);

var MobileFilters = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r317"
} : 0)( true ? {
  name: "bkk0sw",
  styles: "display:none;@media screen and (max-width: 991px){display:block;position:relative;}"
} : 0);

var MobileWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r316"
} : 0)( true ? {
  name: "mzbwu1",
  styles: "background-color:var(--white);position:absolute;display:flex;width:100%;justify-content:flex-end;padding:0px 20px"
} : 0);

var _ref5 =  true ? {
  name: "zigzo6",
  styles: "padding-top:40px;padding-bottom:40px"
} : 0;

var _ref6 =  true ? {
  name: "1j54aji",
  styles: "top:10px"
} : 0;

var SearchWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r315"
} : 0)("display:flex;align-items:center;justify-content:center;z-index:1101;position:fixed;", function (props) {
  if (props.collection) {
    return "top: 6px;";
  } else {
    return "top: 6px;";
  }
}, " ", function (props) {
  if (props.showNews) {
    return _ref6;
  }
}, "@media screen and (min-width: 1421px){", function (props) {
  if (props.width) {
    return (
      /*#__PURE__*/

      /*#__PURE__*/
      (0,emotion_react_browser_esm/* css */.iv)("width:", 0.37 * props.width, "px;left:", 0.15 * props.width, "px;" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0)
    );
  }
}, ";}@media screen and (max-width: 1420px){top:0;position:static;background-color:var(--white);padding-top:10px;padding-bottom:10px;", function (props) {
  if (props.collection) {
    return _ref5;
  }
}, ";}@media screen and (max-width: 991px){background-color:#f3f3f5;padding-left:20px;padding-right:20px;}" + ( true ? "" : 0));

var Filters_ref =  true ? {
  name: "m1ps4w",
  styles: "top:72px"
} : 0;

var _ref2 =  true ? {
  name: "11bnwp6",
  styles: "top:114px"
} : 0;

var _ref3 =  true ? {
  name: "s0drx2",
  styles: "top:109px;margin-top:-10px"
} : 0;

var _ref4 =  true ? {
  name: "s0drx2",
  styles: "top:109px;margin-top:-10px"
} : 0;

var Section = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r314"
} : 0)("position:relative;@media screen and (max-width: 1420px){position:sticky;top:72px;z-index:501;", function (props) {
  if (props.collection && props.showNews) {
    return _ref4;
  }

  if (props.collection && !props.showNews) {
    return _ref3;
  }

  if (props.showNews) {
    return _ref2;
  }
}, ";}@media screen and (max-width: 600px){", function (props) {
  if (props.collection) {
    return Filters_ref;
  }
}, ";}" + ( true ? "" : 0));

var Filters_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r313"
} : 0)( true ? {
  name: "13okvom",
  styles: "display:flex;justify-content:center;position:fixed;width:100%;background:#e6e6e6;padding-bottom:9px;padding-top:0;z-index:501;transform:translateY(-1px);@media screen and (max-width: 1420px){position:static;padding-top:0;}@media screen and (max-width: 990px){background-color:white;justify-content:flex-end;padding:0px 10%;}@media screen and (max-width: 899px){position:relative;padding-top:10px;}"
} : 0);

var FilterOptions = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "eymc6r312"
} : 0)( true ? {
  name: "1hg2ne8",
  styles: "border-radius:15px;border-top-left-radius:0;border-top-right-radius:0;text-transform:capitalize;padding:11px 13px"
} : 0);

var FilterWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r311"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var AdvancedFilter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "eymc6r310"
} : 0)("border-radius:15px;border-top-left-radius:0;border-top-right-radius:0;padding:10px;background-color:#e62f34;@media screen and (max-width: 991px){font-size:", 10 / 16, "rem;}" + ( true ? "" : 0));

var FilterImg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "eymc6r39"
} : 0)( true ? {
  name: "9v5wj1",
  styles: "width:11px;height:11px;vertical-align:middle;margin-right:5px"
} : 0);

var FilterText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eymc6r38"
} : 0)( true ? "" : 0);

var OptionsImg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "eymc6r37"
} : 0)( true ? {
  name: "yr3mxx",
  styles: "margin-right:4px;min-width:20px;min-height:20px;max-width:20px;max-height:20px"
} : 0);

var StyledRadioTab = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RadioTab,  true ? {
  target: "eymc6r36"
} : 0)( true ? {
  name: "1qx4gu9",
  styles: "margin-right:30px"
} : 0);

var OptionsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r35"
} : 0)("display:flex;margin-right:33px;& ", FilterOptions, "{margin-right:7px;}" + ( true ? "" : 0));

var FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r34"
} : 0)( true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0);

var Badge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r33"
} : 0)("min-width:20px;min-height:20px;border-radius:10px;display:flex;justify-content:center;align-items:center;position:absolute;color:var(--white);background-color:var(--color-blue-main);font-size:", 12 / 16, "rem;font-weight:600;top:30px;right:0;" + ( true ? "" : 0));

var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eymc6r32"
} : 0)( true ? {
  name: "1pxc938",
  styles: "cursor:pointer;font-weight:500;font-family:var(--font-family);width:100%;text-align:center;font-size:12px"
} : 0);

var StyledCheckbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Checkbox_Checkbox/* default */.Z,  true ? {
  target: "eymc6r31"
} : 0)( true ? {
  name: "10de9tt",
  styles: "padding:0;margin-right:5px;& .MuiSvgIcon-root{width:15px;height:15px;color:var(--white);}"
} : 0);

var LabelWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymc6r30"
} : 0)( true ? {
  name: "7rctjs",
  styles: "display:flex;width:100%;align-items:center;justify-content:center;max-height:40px"
} : 0);

/* harmony default export */ var proyectos_Filters = (Filters);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
;// CONCATENATED MODULE: ./shared/models/adapters/realestate.adapter.js
var realestateFiltersAdapter = function realestateFiltersAdapter(filters) {
  var _newFilters$onlyUnits;

  var newFilters = {};
  var _filters$locations = filters.locations,
      locations = _filters$locations === void 0 ? [] : _filters$locations,
      _filters$typeProperty = filters.typeProperty,
      typeProperty = _filters$typeProperty === void 0 ? [] : _filters$typeProperty,
      page = filters.page,
      businessTypes = filters.businessTypes,
      amountMax = filters.amountMax,
      amountMin = filters.amountMin,
      bedrooms = filters.bedrooms,
      bathrooms = filters.bathrooms,
      parkings = filters.parkings,
      floorLevels = filters.floorLevels,
      _filters$propertyStat = filters.propertyStatus,
      propertyStatus = _filters$propertyStat === void 0 ? [] : _filters$propertyStat,
      _filters$exclusives = filters.exclusives,
      exclusives = _filters$exclusives === void 0 ? null : _filters$exclusives,
      _filters$collection = filters.collection,
      collection = _filters$collection === void 0 ? null : _filters$collection,
      _filters$onlyUnits = filters.onlyUnits,
      onlyUnits = _filters$onlyUnits === void 0 ? null : _filters$onlyUnits,
      _filters$currencyType = filters.currencyType,
      currencyType = _filters$currencyType === void 0 ? "rd" : _filters$currencyType,
      _filters$improvements = filters.improvements,
      improvements = _filters$improvements === void 0 ? [] : _filters$improvements,
      _filters$sector = filters.sector,
      sector = _filters$sector === void 0 ? [] : _filters$sector,
      _filters$sectorName = filters.sectorName,
      sectorName = _filters$sectorName === void 0 ? null : _filters$sectorName,
      _filters$cityName = filters.cityName,
      cityName = _filters$cityName === void 0 ? null : _filters$cityName,
      _filters$orderBy = filters.orderBy,
      orderBy = _filters$orderBy === void 0 ? null : _filters$orderBy,
      _filters$extraBusines = filters.extraBusinessTypes,
      extraBusinessTypes = _filters$extraBusines === void 0 ? null : _filters$extraBusines,
      _filters$recent = filters.recent,
      recent = _filters$recent === void 0 ? null : _filters$recent;

  var _getCityAndSector = getCityAndSector(locations),
      city = _getCityAndSector.city,
      sectorCt = _getCityAndSector.sectorCt;

  var propertyTypes = getTypeProperty(typeProperty);
  newFilters.sector = sectorCt + sector.map(function (x) {
    return x.id;
  }).toString();
  newFilters.city = city;
  newFilters.type = propertyTypes;
  newFilters.page = page;
  newFilters.business = businessTypes;
  newFilters.bedrooms = bedrooms;
  newFilters.bathrooms = bathrooms;
  newFilters.parkings = parkings;
  newFilters.feature = getImprovements(improvements);
  newFilters.floorLevels = floorLevels;
  newFilters.exclusives = exclusives;
  newFilters.collection = collection;
  newFilters.onlyUnits = onlyUnits;
  newFilters.sectorName = sectorName ? sectorName.replaceAll("-", "+") : null;
  newFilters.cityName = cityName ? cityName.replaceAll("-", "+") : null;
  newFilters.extraBusinessTypes = Array.isArray(extraBusinessTypes) ? extraBusinessTypes[0] : null;

  if (orderBy) {
    console.log({
      orderBy: orderBy
    });
    newFilters.sort = "price";
    newFilters.direction = orderBy == "mayor" ? "desc" : "asc";
  }

  if (recent) {
    newFilters.recent = 1;
  }

  if (amountMax && amountMin) {
    newFilters.price = "".concat(amountMin, "...").concat(amountMax, ",").concat(currencyType);
  } else if (amountMin) {
    newFilters.price = ">=".concat(amountMin, ",").concat(currencyType);
  } else if (amountMax) {
    newFilters.price = "<=".concat(amountMax, ",").concat(currencyType);
  }

  if (((_newFilters$onlyUnits = newFilters.onlyUnits) === null || _newFilters$onlyUnits === void 0 ? void 0 : _newFilters$onlyUnits.length) == 2) {
    newFilters.onlyUnits = null;
  } else {
    newFilters.onlyUnits = onlyUnits[0];
  }

  if (propertyTypes.includes("project")) {
    var allTypes = propertyTypes.split(",").filter(function (x) {
      return x !== "project";
    });
    newFilters.type = allTypes.join(",");
    newFilters.onlyUnits = "false";
  }

  if (newFilters.city) {
    newFilters.cityName = null;
  }

  if (newFilters !== null && newFilters !== void 0 && newFilters.sector) {
    newFilters.sectorName = null;
  } // // Filtro construidas
  // if (propertyStatus.includes("2") ) {
  //   newFilters.onlyUnitss = true;
  // } else {
  //   newFilters.onlyUnitss = false;
  // }
  // // Filtro En construcción
  // if (propertyStatus.includes("1")) {
  //   newFilters.type = "project";
  // }
  // if (propertyStatus.includes("1") && propertyStatus.includes("2")) {
  //   newFilters.type = propertyTypes;
  //   newFilters.onlyUnitss = false;
  // }


  if ((bedrooms === null || bedrooms === void 0 ? void 0 : bedrooms.length) > 0) {
    newFilters.bedrooms = bedrooms.join(",");
  }

  var usedFilters = {}; // Getting rid of empty string/nulls/false

  Object.keys(newFilters).forEach(function (keys) {
    if (!isNull(newFilters[keys])) {
      usedFilters[keys] = newFilters[keys];
    }
  });
  return usedFilters;
};

function getCityAndSector(locations) {
  var city = [];
  var sector = [];

  for (var index = 0; index < locations.length; index++) {
    var element = locations[index];

    if (element.isSector) {
      if (!sector.includes(element.id)) {
        sector.push(element.id);
      } // if (!city.includes(element.city_id)) {
      //   city.push(element.city_id);
      // }

    } else {
      if (!city.includes(element.id)) {
        city.push(element.id);
      }
    }
  }

  return {
    city: city.join(","),
    sectorCt: sector.join(",")
  };
}

function getTypeProperty() {
  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return types.map(function (item) {
    if (item.slug) {
      return item.slug;
    }

    if (item.value) {
      return item.value;
    }

    if (typeof item === "string") {
      return item;
    }

    return "";
  }).join(",");
}

function getImprovements() {
  var improvements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return improvements.map(function (item) {
    if (item.value) {
      return item.value;
    }

    if (typeof item === "string") {
      return item;
    }

    return "";
  }).join(",");
}

var isNull = function isNull(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (value) {
    return false;
  }

  return true;
};
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/components/loading-bubbles/index.tsx
var loading_bubbles = __webpack_require__(47364);
// EXTERNAL MODULE: ./shared/components/property-card/index.tsx + 1 modules
var property_card = __webpack_require__(39470);
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
// EXTERNAL MODULE: ./shared/components/contact-dialog/index.tsx
var contact_dialog = __webpack_require__(10606);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
;// CONCATENATED MODULE: ./shared/hooks/use-width.hook.ts



function useWidth() {
  var theme = (0,useTheme/* default */.Z)();

  var keys = (0,toConsumableArray/* default */.Z)(theme.breakpoints.keys).reverse();

  return keys.reduce(function (output, key) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var matches = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || "xs";
}
;// CONCATENATED MODULE: ./shared/hooks/use-media-query.ts


function use_media_query_useMediaQuery() {
  var width = useWidth();
  return {
    isMobile: ["xs", "sm"].includes(width),
    isTablet: ["md"].includes(width),
    isLargeScreen: ["lg", "xl"].includes(width),
    isDesktop: ["lg"].includes(width),
    isLargeDesktop: ["xl"].includes(width)
  };
}

/* harmony default export */ var use_media_query = (use_media_query_useMediaQuery);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/PropertyList.tsx


function PropertyList_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















function PropertyList(props) {
  var _data$pages$, _data$pages$2;

  var _useMediaQuery = use_media_query(),
      isMobile = _useMediaQuery.isMobile;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var ref = (0,useGetPersintParamas_hook/* default */.Z)();
  var translation = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter.noResult");
  var router = (0,next_router.useRouter)(); // const { loadingRequest, setLoadingPropertyAction, clearPropertyAction } =
  //   usePropertiesLoading();

  var scrollRef = (0,react.useRef)(null);

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var getMore = props.getMore,
      hasNextPage = props.hasNextPage,
      data = props.data,
      isError = props.isError,
      isSuccess = props.isSuccess,
      detailPath = props.detailPath,
      isLoading = props.isLoading; // set scroll restoration to manual

  (0,react.useEffect)(function () {
    if ("scrollRestoration" in history && history.scrollRestoration !== "manual") {
      history.scrollRestoration = "manual";
    }
  }, []); // handle and store scroll position

  (0,react.useEffect)(function () {
    var handleRouteChange = function handleRouteChange(url) {
      //if going to a property, save the position and path
      if (url.startsWith("/propiedad/") || url.startsWith("/collection/propiedad/")) {
        sessionStorage.setItem("scrollPosition", window.scrollY.toString());
        sessionStorage.setItem("scrollPositionPath", location.pathname + location.search);
      }
    };

    router.events.on("routeChangeStart", handleRouteChange);
    return function () {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router.events]); // restore scroll position

  (0,react.useEffect)(function () {
    if (scrollRef.current && "scrollPosition" in sessionStorage) {
      var _sessionStorage$getIt;

      var prevPath = sessionStorage.getItem("prevPath");
      var scrollPositionPath = (_sessionStorage$getIt = sessionStorage.getItem("scrollPositionPath")) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : ""; //restore position if coming from a property
      //and the target is the same path

      if ((prevPath !== null && prevPath !== void 0 && prevPath.startsWith("/propiedad/") || prevPath !== null && prevPath !== void 0 && prevPath.startsWith("/collection/propiedad/")) && router.asPath === scrollPositionPath) {
        window.scrollTo(0, Number(sessionStorage.getItem("scrollPosition")));
      }

      sessionStorage.removeItem("scrollPosition");
      sessionStorage.removeItem("scrollPositionPath");
    }
  }, []);

  if (isLoading && (data === null || data === void 0 ? void 0 : (_data$pages$ = data.pages[0]) === null || _data$pages$ === void 0 ? void 0 : _data$pages$.data.length) === undefined) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SearchResults, null, (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, null));
  }

  if (isSuccess && (data === null || data === void 0 ? void 0 : (_data$pages$2 = data.pages[0]) === null || _data$pages$2 === void 0 ? void 0 : _data$pages$2.data.length) <= 0) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SearchResults, null, (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: translation("textContent"),
      modalComponent: (0,emotion_react_browser_esm/* jsx */.tZ)(ModalBtn, {
        onClick: handleOpen
      }, translation("textBoton"))
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_dialog/* default */.Z, {
      open: open,
      onClose: handleClose,
      classNameModalButton: "enviar-formulario-contacto-menu"
    }));
  }

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SearchResults, null, (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Ha ocurrido un error"
    }));
  }

  var getUrls = function getUrls(item) {
    var _item$city2, _item$city2$replaceAl;

    var url = detailPath(item);

    if (ref) {
      var _item$city, _item$city$replaceAll;

      return "".concat(url).concat(ref, "&city=").concat(item === null || item === void 0 ? void 0 : (_item$city = item.city) === null || _item$city === void 0 ? void 0 : (_item$city$replaceAll = _item$city.replaceAll(" ", "-")) === null || _item$city$replaceAll === void 0 ? void 0 : _item$city$replaceAll.toLowerCase()).concat(isMobile ? "&mobile=true" : "");
    }

    return "".concat(url, "?city=").concat(item === null || item === void 0 ? void 0 : (_item$city2 = item.city) === null || _item$city2 === void 0 ? void 0 : (_item$city2$replaceAl = _item$city2.replaceAll(" ", "-")) === null || _item$city2$replaceAl === void 0 ? void 0 : _item$city2$replaceAl.toLowerCase()).concat(isMobile ? "&mobile=true" : "");
  };

  var handleChangePage = function handleChangePage(page) {
    getMore(page);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    ref: scrollRef
  }, (0,emotion_react_browser_esm/* jsx */.tZ)((react_infinite_scroller_default()), {
    loadMore: handleChangePage,
    hasMore: hasNextPage,
    loader: (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, null)
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SearchContentResults, null, data === null || data === void 0 ? void 0 : data.pages.map(function (page) {
    return page.data.map(function (item) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
        key: item.id,
        href: getUrls(item),
        passHref: true,
        target: !isMobile ? "_blank" : "_self"
      }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
        target: !isMobile ? "_blank" : "_self",
        rel: "nofollow noopener noreferrer"
      }, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledPropertyCard, item)));
    });
  }))));
}

/* harmony default export */ var proyectos_PropertyList = (PropertyList);

var StyledPropertyCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(property_card/* default */.Z,  true ? {
  target: "erel5zb3"
} : 0)( true ? {
  name: "1wvq27v",
  styles: "@media screen and (max-width: 500px){width:315px;}"
} : 0);

var SearchContentResults = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "erel5zb2"
} : 0)( true ? {
  name: "e05jsp",
  styles: "display:grid;justify-items:center;justify-content:space-between;grid-template-columns:calc(24.75% - 6px) calc(24.75% - 6px) calc(24.75% - 6px) calc(24.75% - 6px);gap:30px 12px;@media screen and (max-width: 1299px){grid-template-columns:calc(33.333% - 6px) calc(33.333% - 6px) calc(\n        33.333% - 6px\n      );gap:30px 10px;}@media screen and (max-width: 991px){grid-template-columns:calc(50% - 5px) calc(50% - 5px);gap:30px 10px;}@media screen and (max-width: 576px){grid-template-columns:100%;gap:30px 0px;}"
} : 0);

var SearchResults = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "erel5zb1"
} : 0)( true ? {
  name: "t6p6gz",
  styles: "display:flex;width:100%;height:100%;justify-content:center;align-items:center"
} : 0);

var ModalBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "erel5zb0"
} : 0)( true ? {
  name: "ccum55",
  styles: "cursor:pointer;font-size:19px;font-weight:600;color:var(--color-secondary);text-decoration:underline"
} : 0);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js + 1 modules
var emotion_css_esm = __webpack_require__(18872);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./api/clients/search-queries/search-queries.request.ts + 1 modules
var search_queries_request = __webpack_require__(63081);
// EXTERNAL MODULE: ./custom-hooks/useSnackBar.hook.ts
var useSnackBar_hook = __webpack_require__(71652);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/BookmarkBorder.js
var BookmarkBorder = __webpack_require__(61205);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./store/feature/auth/auth-dialog.slice.ts
var auth_dialog_slice = __webpack_require__(54540);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/save-search.button.tsx


function save_search_button_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















function SaveSearchQueryButton(_ref) {
  var filters = _ref.filters;
  var t = (0,next_intl_cjs_production_min.useTranslations)("realestateList");

  var _useSnackBar = (0,useSnackBar_hook/* default */.Z)(),
      showMessage = _useSnackBar.showMessage;

  var user = (0,redux_hooks/* useAppSelector */.C)(function (_ref2) {
    var Auth = _ref2.Auth;
    return Auth.user;
  });
  var dispatch = (0,redux_hooks/* useAppDispatch */.T)();

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var _useMutation = (0,useMutation/* useMutation */.D)(search_queries_request/* saveSearchQuery */.pI, {
    onSuccess: function onSuccess() {
      var _filters$locations, _filters$sector;

      event({
        event_name: "save_search",
        body: {
          ciudad_buscada: filters === null || filters === void 0 ? void 0 : (_filters$locations = filters.locations) === null || _filters$locations === void 0 ? void 0 : _filters$locations.map(function (location) {
            return location === null || location === void 0 ? void 0 : location.description;
          }),
          tipo_negocio: filters === null || filters === void 0 ? void 0 : filters.businessTypes,
          tipo_propiedad: filters === null || filters === void 0 ? void 0 : filters.typeProperty,
          sector: filters === null || filters === void 0 ? void 0 : (_filters$sector = filters.sector) === null || _filters$sector === void 0 ? void 0 : _filters$sector.map(function (sector) {
            return sector === null || sector === void 0 ? void 0 : sector.description;
          }),
          habitaciones: filters === null || filters === void 0 ? void 0 : filters.bedrooms,
          precio_maximo: filters === null || filters === void 0 ? void 0 : filters.precio_maximo,
          precio_minimo: filters === null || filters === void 0 ? void 0 : filters.precio_minimo
        }
      });
      showMessage((0,emotion_react_browser_esm/* jsx */.tZ)(SuccessSnackBody, null, t("searchQuery.success"), "\xA0", (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
        href: pages_path/* CPagesPath.es.ProfileSearchHistory */.K.es.ProfileSearchHistory
      }, t("searchQuery.link"))), {
        variant: "success"
      });
    },
    onError: function onError() {
      return showMessage(t("searchQuery.error"), {
        variant: "error"
      });
    }
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading,
      mutateAsync = _useMutation.mutateAsync;

  var saveSearch = function saveSearch() {
    if (!user) return dispatch((0,auth_dialog_slice/* openAuthDialog */.dn)("signin"));
    mutateAsync({
      parameters: filters
    });
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    className: saveSearchButton,
    disabled: isLoading,
    onClick: saveSearch
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BookmarkBorder/* default */.Z, null), t("searchQuery.save"));
}
var saveSearchButton = /*#__PURE__*/(0,emotion_css_esm/* css */.iv)( true ? {
  name: "yuylsx",
  styles: "padding:4px 25px 4px 20px;margin-left:10px"
} : 0);

var SuccessSnackBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1umd84u0"
} : 0)( true ? {
  name: "a0hj9",
  styles: "a{color:white;font-weight:bold;:hover{text-decoration:underline;}}"
} : 0);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/ResultFilterBar.tsx


function ResultFilterBar_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var handleClick = function handleClick(id, isMobile) {
  var _document$getElementB;

  (_document$getElementB = document.getElementById(isMobile ? id : "modal-propertyList")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.click();
};

var ResultFilterBar = function ResultFilterBar(props) {
  var _resultsFilters$count;

  var resultsFilters = props.resultsFilters,
      filters = props.filters,
      isLoading = props.isLoading;

  var _useState = (0,react.useState)(false),
      isMobile = _useState[0],
      setIsMobile = _useState[1];

  var translation = (0,next_intl_cjs_production_min.useTranslations)("realestateList");
  var size = (0,useWindowsSize_hook/* default */.Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;
  (0,react.useEffect)(function () {
    if (width > 899) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);
  var showSaveSearch = true;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ResultFilterBar_Filters, null, (resultsFilters === null || resultsFilters === void 0 ? void 0 : resultsFilters.cities.length) > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(ResultFilterBar_Item, {
    onClick: function onClick() {
      return handleClick("locations", isMobile);
    }
  }, translation("city"), ":", (0,emotion_react_browser_esm/* jsx */.tZ)(Result, null, " ", resultsFilters === null || resultsFilters === void 0 ? void 0 : resultsFilters.cities.join(", "))), resultsFilters.sector.length > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(ResultFilterBar_Item, {
    onClick: function onClick() {
      return handleClick("filterSector", isMobile);
    }
  }, "SECTOR:", (0,emotion_react_browser_esm/* jsx */.tZ)(Result, null, " ", resultsFilters === null || resultsFilters === void 0 ? void 0 : resultsFilters.sector.join(", "))), resultsFilters.typeProperty.length > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(ResultFilterBar_Item, {
    onClick: function onClick() {
      return handleClick("filterType", isMobile);
    }
  }, translation("type"), ":", (0,emotion_react_browser_esm/* jsx */.tZ)(Result, null, " ", resultsFilters === null || resultsFilters === void 0 ? void 0 : resultsFilters.typeProperty.join(", ")))), !isLoading && (0,emotion_react_browser_esm/* jsx */.tZ)(Counter, null, "(", translation("count", {
    count: (_resultsFilters$count = resultsFilters === null || resultsFilters === void 0 ? void 0 : resultsFilters.count) !== null && _resultsFilters$count !== void 0 ? _resultsFilters$count : null
  }), ")", showSaveSearch && (0,emotion_react_browser_esm/* jsx */.tZ)(SaveSearchQueryButton, {
    filters: filters
  })));
};

/* harmony default export */ var proyectos_ResultFilterBar = (ResultFilterBar);

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqd9hn04"
} : 0)( true ? {
  name: "182sz1u",
  styles: "display:flex;flex-direction:column;justify-content:center;align-items:center;position:relative;margin:30px auto;@media screen and (max-width: 899px){margin:20px auto 30px;}"
} : 0);

var ResultFilterBar_Filters = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eqd9hn03"
} : 0)( true ? {
  name: "192tger",
  styles: "background-color:var(--color-blue-main);display:flex;align-items:center;gap:20px;padding:6px 20px;border-radius:50px;list-style:none;margin-bottom:10px;max-width:fit-content;@media screen and (max-width: 867px){flex-direction:column;align-items:flex-start;padding:15px 30px;gap:10px;}"
} : 0);

var ResultFilterBar_Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "eqd9hn02"
} : 0)( true ? {
  name: "3kjf5y",
  styles: "color:#fff;font-weight:bold;font-size:12px;cursor:pointer;text-transform:uppercase;& a{color:#fff;text-decoration:none;}@media screen and (max-width: 867px){max-width:550px;}"
} : 0);

var Result = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eqd9hn01"
} : 0)( true ? {
  name: "1ityoz",
  styles: "font-weight:lighter"
} : 0);

var Counter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eqd9hn00"
} : 0)( true ? {
  name: "456tkj",
  styles: "font-size:14px;color:var(--color-gray-01);font-style:italic;max-width:fit-content;text-align:center"
} : 0);
// EXTERNAL MODULE: ./shared/models/functions/title-dinamic-properties.helper.ts
var title_dinamic_properties_helper = __webpack_require__(16371);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 7 modules
var TextField = __webpack_require__(98271);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Reorder.js
var Reorder = __webpack_require__(7444);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
;// CONCATENATED MODULE: ./shared/components/orderby-filter/index.tsx



function orderby_filter_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




 // import { Filters } from "shared/models/const/filters";




function OrderBy(props) {
  var _React$useState = react.useState(""),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  var options = [{
    id: "menor",
    name: "Menor a mayor precio"
  }, {
    id: "mayor",
    name: "Mayor a menor precio"
  }, {
    id: "recent",
    name: "Más recientes"
  }];

  var handleChange = function handleChange(event) {
    console.log(event.target.value);
    props.handle("", event.target.value);
  };

  (0,react.useEffect)(function () {
    if (query !== null && query !== void 0 && query.orderBy) {
      setState(query === null || query === void 0 ? void 0 : query.orderBy);
    } else {
      if (query !== null && query !== void 0 && query.recent) {
        setState("recent");
      } else {
        setState("");
      }
    }
  }, [query]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentFilter, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Filter, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Reorder/* default */.Z, null), (0,emotion_react_browser_esm/* jsx */.tZ)(orderby_filter_Label, null, "Ordenar por:"), (0,emotion_react_browser_esm/* jsx */.tZ)(CustomTextField, {
    value: state,
    select: true,
    onChange: handleChange
  }, options.map(function (option) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(CustomItem, {
      key: option.id,
      value: option.id
    }, option.name);
  })), state != "" && (0,emotion_react_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
    onClick: function onClick() {
      return props.handle("orderBy", "");
    },
    "aria-label": "delete"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Close/* default */.Z, null))));
}

/* harmony default export */ var orderby_filter = (OrderBy);

var ContentFilter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eeawz6i4"
} : 0)( true ? {
  name: "8w2ac9",
  styles: "margin-bottom:20px;width:100%;.MuiTextField-root{*{border:none;}}"
} : 0);

var orderby_filter_Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eeawz6i3"
} : 0)( true ? {
  name: "1wk1eiy",
  styles: "font-size:1rem;color:var(--color-blue-main);font-weight:600"
} : 0);

var CustomItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MenuItem/* default */.Z,  true ? {
  target: "eeawz6i2"
} : 0)( true ? {
  name: "16gdv26",
  styles: "&.Mui-selected{background-color:var(--color-blue-main);color:var(--white);&:hover{background-color:var(--color-blue-main);color:var(--white);}}:hover{background-color:var(--color-blue-main);color:var(--white);}"
} : 0);

var CustomTextField = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TextField/* default */.Z,  true ? {
  target: "eeawz6i1"
} : 0)( true ? {
  name: "1np61ja",
  styles: "width:220px;.MuiSelect-select.MuiSelect-outlined{color:var(--color-dark-gray);font-weight:500;}"
} : 0);

var Filter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eeawz6i0"
} : 0)( true ? {
  name: "1d5mc6n",
  styles: "display:flex;align-items:center;justify-content:flex-end;width:100%;column-gap:2px;svg{color:var(--color-blue-main);}@media screen and (max-width: 600px){justify-content:center;}"
} : 0);
// EXTERNAL MODULE: ./store/properties-loading/index.tsx
var properties_loading = __webpack_require__(9056);
// EXTERNAL MODULE: ./shared/components/layout/index.tsx + 41 modules
var layout = __webpack_require__(54525);
// EXTERNAL MODULE: ./shared/models/const/seo.const.ts
var seo_const = __webpack_require__(4674);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Home.js
var Home = __webpack_require__(76638);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(13379);
;// CONCATENATED MODULE: ./shared/components/Breadcrumbs.tsx








var Breadcrumbs = function Breadcrumbs(_ref) {
  var onChange = _ref.onChange;
  var router = (0,next_router.useRouter)(); // Extraer la ruta sin parámetros de consulta

  var pathWithoutQuery = (0,react.useMemo)(function () {
    return router.asPath.split("?")[0];
  }, [router.asPath]); // Construir breadcrumbs basados en la ruta

  var breadcrumbs = (0,react.useMemo)(function () {
    // Separar segmentos de la ruta y filtrar los vacíos
    var pathSegments = pathWithoutQuery.split("/").filter(Boolean); // Siempre empezar con Inicio

    var breadcrumbItems = [{
      name: "Inicio",
      path: "/"
    }]; // Construir rutas acumulativas

    var currentPath = "";
    pathSegments.forEach(function (segment) {
      currentPath += "/".concat(segment); // Formatear el nombre del segmento para que sea más legible

      var formattedName = segment.replace(/-/g, " ").replace(/\b\w/g, function (l) {
        return l.toUpperCase();
      }); // Capitalizar cada palabra

      breadcrumbItems.push({
        name: formattedName,
        path: currentPath
      });
    });
    return breadcrumbItems;
  }, [pathWithoutQuery]); // JSON-LD para SEO

  var jsonLd = (0,react.useMemo)(function () {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map(function (crumb, index) {
        return {
          "@type": "ListItem",
          position: index + 1,
          name: crumb.name,
          item: "".concat("https://remaxrd.com" || 0).concat(crumb.path)
        };
      })
    };
  }, [breadcrumbs]); // Función para manejar el cambio de ruta

  var onChangeRoute = function onChangeRoute(path) {
    return function (e) {// Si existe la función onChange, ejecutarla con la ruta
      // if (onChange) {
      //   e.preventDefault();
      //   console.log("path", path);
      //   onChange(path);
      //   // La navegación se manejará externamente por la función onChange
      // }
      // Si no hay onChange, la navegación ocurrirá normalmente por el Link
    };
  }; // No mostrar breadcrumbs en la página de inicio


  if (router.pathname === "/") return null;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(jsonLd)
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(BreadcrumbNav, {
    "aria-label": "breadcrumb"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BreadcrumbList, null, breadcrumbs.map(function (crumb, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(BreadcrumbItem, {
      key: "".concat(crumb.path, "-").concat(index),
      isLast: index === breadcrumbs.length - 1
    }, index > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(Separator, {
      "aria-hidden": "true"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ArrowForwardIos/* default */.Z, {
      fontSize: "small"
    })), index === 0 ? (0,emotion_react_browser_esm/* jsx */.tZ)(BreadcrumbLink, {
      href: crumb.path // passHref
      // shallow={true}
      // legacyBehavior

    }, (0,emotion_react_browser_esm/* jsx */.tZ)(HomeIconWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Home/* default */.Z, {
      fontSize: "small"
    })), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, crumb.name)) : index === breadcrumbs.length - 1 ? (0,emotion_react_browser_esm/* jsx */.tZ)(CurrentPage, {
      "aria-current": "page"
    }, crumb.name) : (0,emotion_react_browser_esm/* jsx */.tZ)(BreadcrumbLink, {
      href: crumb.path // shallow={true}
      // passHref
      // legacyBehavior

    }, crumb.name));
  }))));
};

/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs); // Estilos con Material UI styled

var BreadcrumbNav = (0,styled/* default */.ZP)("nav")({
  width: "100%",
  padding: "0 0 20px 0",
  fontFamily: "var(--font-family)"
});
var BreadcrumbList = (0,styled/* default */.ZP)("ol")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  margin: 0,
  padding: 0,
  listStyle: "none"
});
var BreadcrumbItem = (0,styled/* default */.ZP)("li", {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "isLast";
  }
})(function (_ref2) {
  var isLast = _ref2.isLast;
  return {
    display: "flex",
    alignItems: "center",
    color: isLast ? "var(--color-blue-main)" : "var(--color-gray-01)",
    fontSize: "0.875rem",
    fontWeight: 600,
    a: {
      display: "flex",
      alignItems: "center",
      gap: "2px",
      color: isLast ? "var(--color-blue-main)" : "var(--color-gray-01)",
      "&:hover": {
        color: "var(--color-secondary)",
        textDecoration: "underline"
      }
    }
  };
});
var Separator = (0,styled/* default */.ZP)("span")({
  margin: "0 8px",
  color: "var(--color-gray-01)",
  fontSize: "0.875rem",
  svg: {
    fontSize: "1rem",
    marginTop: "4px"
  }
});
var BreadcrumbLink = (0,styled/* default */.ZP)("a")({
  color: "var(--color-gray-01) !important",
  textDecoration: "none",
  transition: "color 0.2s ease",
  display: "flex",
  alignItems: "center",
  "&:hover": {
    color: "var(--color-secondary)",
    textDecoration: "underline"
  },
  "& span": {
    marginLeft: "4px"
  }
});
var HomeIconWrapper = (0,styled/* default */.ZP)("div")({
  display: "flex",
  alignItems: "center",
  fontSize: "1.1rem"
});
var CurrentPage = (0,styled/* default */.ZP)("span")({
  fontWeight: 600
});
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/ProjectList.tsx





function ProjectList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProjectList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProjectList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProjectList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function ProjectList_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















function ProjectList(props) {
  var _useState = (0,react.useState)({}),
      resultsFilters = _useState[0],
      setResultsFilters = _useState[1];

  var _usePropertiesLoading = (0,properties_loading/* usePropertiesLoading */.Dg)(),
      loadingRequest = _usePropertiesLoading.loadingRequest,
      setLoadingPropertyAction = _usePropertiesLoading.setLoadingPropertyAction,
      clearPropertyAction = _usePropertiesLoading.clearPropertyAction;

  var _useState2 = (0,react.useState)(false),
      haveResultsFilters = _useState2[0],
      setHaveResultsFilters = _useState2[1];

  var filters = props.filters;
  var translations = (0,next_intl_cjs_production_min.useTranslations)("realestateList");
  var router = (0,next_router.useRouter)();
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  var locationUrl = (0,react.useRef)(function () {
    return validateUrlAsKey(router.asPath);
  });

  var _useState3 = (0,react.useState)(false),
      enableReq = _useState3[0],
      setEnableReq = _useState3[1];

  var request = function request(params) {
    var _params$pageParam = params.pageParam,
        pageParam = _params$pageParam === void 0 ? 1 : _params$pageParam;
    var newFilters = realestateFiltersAdapter(ProjectList_objectSpread(ProjectList_objectSpread({}, filters), {}, {
      page: pageParam
    }));

    if (newFilters.sector) {
      delete newFilters.city;
    } // @ts-ignore


    return (0,realestate_request/* getRealestate */._G)(newFilters);
  }; //TODO: check bug where users scrolling to reach page two
  //and changing a filter results in page=1 fetching once
  //and page=2 getting fetched several times.


  var _useInfiniteQuery = (0,useInfiniteQuery/* useInfiniteQuery */.N)([locationUrl.current()], request, {
    getNextPageParam: function getNextPageParam(lastPage, pages) {
      if (lastPage.meta.last_page == lastPage.meta.current_page) {
        return false;
      }

      return pages.length + 1;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    //ignore paramless urls unless they are dynamic SEO pages
    enabled: (/\?/.test(router.asPath) || router.pathname === seo_const/* seoPathname */.G) && enableReq
  }),
      data = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isLoading = _useInfiniteQuery.isLoading,
      hasNextPage = _useInfiniteQuery.hasNextPage,
      isError = _useInfiniteQuery.isError,
      isSuccess = _useInfiniteQuery.isSuccess,
      refetch = _useInfiniteQuery.refetch;

  var getMore = function getMore() {
    setLoadingPropertyAction(true); // const scroll = window.scrollY * 1.9 - window.scrollY;
    // window.scrollTo({
    //   top: scroll,
    //   behavior: "smooth",
    // });

    if (!loadingRequest && hasNextPage) {
      fetchNextPage().then(function () {
        setLoadingPropertyAction(false);
      });
    }
  };

  (0,react.useEffect)(function () {
    locationUrl.current = function () {
      return validateUrlAsKey(location.pathname + location.search);
    };

    setEnableReq(true);
  }, []);
  (0,react.useEffect)(function () {
    var _data$pages$, _resultsFilters$citie, _resultsFilters$secto, _resultsFilters$typeP;

    var count = data === null || data === void 0 ? void 0 : (_data$pages$ = data.pages[0]) === null || _data$pages$ === void 0 ? void 0 : _data$pages$.meta;
    setResultsFilters({
      cities: filters === null || filters === void 0 ? void 0 : filters.locations.map(function (location) {
        return location === null || location === void 0 ? void 0 : location.description;
      }),
      sector: filters === null || filters === void 0 ? void 0 : filters.sector.map(function (sector) {
        return sector === null || sector === void 0 ? void 0 : sector.description;
      }),
      typeProperty: filters === null || filters === void 0 ? void 0 : filters.typeProperty.map(function (property) {
        var _CPropertyTypes$find;

        if (typeof property == "object") {
          return property === null || property === void 0 ? void 0 : property.name;
        }

        return (_CPropertyTypes$find = property_types/* CPropertyTypes.find */.Rl.find(function (c) {
          return c.slug === property;
        })) === null || _CPropertyTypes$find === void 0 ? void 0 : _CPropertyTypes$find.name;
      }),
      count: count === null || count === void 0 ? void 0 : count.total
    });

    if ((resultsFilters === null || resultsFilters === void 0 ? void 0 : (_resultsFilters$citie = resultsFilters.cities) === null || _resultsFilters$citie === void 0 ? void 0 : _resultsFilters$citie.length) > 0 || (resultsFilters === null || resultsFilters === void 0 ? void 0 : (_resultsFilters$secto = resultsFilters.sector) === null || _resultsFilters$secto === void 0 ? void 0 : _resultsFilters$secto.length) > 0 || (resultsFilters === null || resultsFilters === void 0 ? void 0 : (_resultsFilters$typeP = resultsFilters.typeProperty) === null || _resultsFilters$typeP === void 0 ? void 0 : _resultsFilters$typeP.length) > 0) {
      setHaveResultsFilters(true);
    } else {
      setHaveResultsFilters(false);
    }
  }, [filters, data]);
  (0,react.useEffect)(function () {
    var handleRouteChange = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(forwardPath) {
        var validForwardPath, currentPath, prevPath, comingFromDetailPage, goingToDetailPage;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validForwardPath = validateUrlAsKey(forwardPath);
                currentPath = locationUrl.current();
                prevPath = sessionStorage.getItem("prevPath");
                comingFromDetailPage = (prevPath === null || prevPath === void 0 ? void 0 : prevPath.startsWith("/propiedad/")) || (prevPath === null || prevPath === void 0 ? void 0 : prevPath.startsWith("/collection/propiedad/"));
                goingToDetailPage = forwardPath.startsWith("/propiedad/") || forwardPath.startsWith("/collection/propiedad/");

                if (!comingFromDetailPage && !goingToDetailPage) {
                  //Prevent deleting current path
                  if (validForwardPath !== currentPath) queryClient.removeQueries([currentPath]); //Going away and not just changing to the same url.
                } else if (!goingToDetailPage && validForwardPath !== currentPath) {
                  queryClient.removeQueries([currentPath]);
                } //Remove any other queries that do not match the current URL


                queryClient.removeQueries({
                  predicate: function predicate(_ref2) {
                    var queryKey = _ref2.queryKey;
                    var key = queryKey[0];
                    var result = typeof key === "string" && (key.startsWith("/propiedades") || key.startsWith("/collection/propiedades")) && key !== currentPath;
                    return result;
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleRouteChange(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    router.events.on("routeChangeStart", handleRouteChange);
    return function () {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router.events]);
  var fetch = (0,lodash.debounce)(function () {
    refetch();
  }, 200);
  (0,react.useEffect)(function () {
    fetch();
  }, [JSON.stringify(filters)]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(layout/* default */.Z, {
    showFooter: !hasNextPage
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ProjectList_Wrapper, {
    id: "property-list"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SearchResult, null, (props === null || props === void 0 ? void 0 : props.seoDynamic) && (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, (0,title_dinamic_properties_helper/* titleDynamicProperties */.n)(router)), props.seoDynamic != true && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, !haveResultsFilters ? (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, translations(props.isCollection ? "titleCollection" : "title")) : (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_ResultFilterBar, {
    resultsFilters: resultsFilters,
    isLoading: isLoading,
    filters: filters
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    my: 3
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    alignItems: "center",
    item: true,
    xs: 12,
    justifyContent: "space-between"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: "auto"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(components_Breadcrumbs, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: "auto"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(orderby_filter, {
    handle: props.orderByFiltersHandler
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null))), (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_PropertyList, {
    isLoading: isLoading,
    getMore: getMore,
    data: data,
    hasNextPage: hasNextPage,
    variant: isError ? "error" : undefined,
    isSuccess: isSuccess,
    detailPath: props.detailPath
  }))));
}
var lastValidUrl = "";
var validUrlCache = new Map();

var validateUrlAsKey = function validateUrlAsKey(url) {
  if (validUrlCache.has(url)) return validUrlCache.get(url);
  var splitUrl = url.split("?");
  var params = new URLSearchParams(splitUrl[1]);
  var amountMax = params.get("amountMax");
  var amountMin = params.get("amountMin");
  if (!splitUrl[1]) return splitUrl[0];

  if (!amountMax && !amountMin) {
    params["delete"]("currencyType");
  } // why is this here?
  //  else if (amountMax && amountMin) {
  //   if (+amountMax < +amountMin) {
  //     return lastValidUrl;
  //   }
  // }


  lastValidUrl = splitUrl[0] + "?" + decodeURIComponent(params.toString());
  validUrlCache.set(url, lastValidUrl);
  return lastValidUrl;
};

var ProjectList_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "eh8hlwn2"
} : 0)( true ? {
  name: "g5897a",
  styles: "width:100%;background-color:var(--white);font-size:0.9rem;padding:50px 0px;@media screen and (max-width: 1299px){font-size:0.8rem;}"
} : 0);

var SearchResult = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "eh8hlwn1"
} : 0)( true ? "" : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "eh8hlwn0"
} : 0)( true ? {
  name: "j21afx",
  styles: "width:100%;text-align:center;text-transform:uppercase;font-size:1.9rem;padding-top:30px;margin-bottom:60px;color:var(--color-blue-main)"
} : 0);
// EXTERNAL MODULE: ./shared/models/functions/realestate-filters-helper.ts + 1 modules
var realestate_filters_helper = __webpack_require__(31248);
;// CONCATENATED MODULE: ./shared/components-pages/proyectos/RealestateList.tsx




function RealestateList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RealestateList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RealestateList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RealestateList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















function adaptQueryParams(query, props) {
  var _props$defaultFilters;

  if (typeof query.bedrooms == "string") {
    query.bedrooms = [query.bedrooms];
  }

  return query && !((_props$defaultFilters = props.defaultFilters) !== null && _props$defaultFilters !== void 0 && _props$defaultFilters.seoDynamic) ? (0,realestate_filters_helper/* parseUrlToRealestateFilters */.Ym)(query) : {};
}

function RealestateList(props) {
  var defaultFilters = props.defaultFilters,
      collection = props.collection;

  var _useState = (0,react.useState)(null),
      title = _useState[0],
      setTitle = _useState[1];

  var _useCities = (0,use_cities_hook/* default */.Z)(),
      cities = _useCities.data;

  var _useState2 = (0,react.useState)(),
      cityId = _useState2[0],
      setCityId = _useState2[1];

  var router = (0,next_router.useRouter)(); // Ref para rastrear si el usuario ha interactuado con los filtros

  var hasUserInteracted = (0,react.useRef)(false); // Ref para evitar actualizar la URL durante la carga inicial

  var isFirstRender = (0,react.useRef)(true);

  var _useSectors = use_sector_hook({
    idCity: cityId,
    onSuccess: function onSuccess(sectors) {
      if (queryFilters.locations.length && queryFilters.sectorName) {
        var selectedSector = sectors.find(function (sector) {
          var _queryFilters$sectorN;

          return sector.description.toLowerCase() == ((_queryFilters$sectorN = queryFilters.sectorName.replaceAll("-", " ")) === null || _queryFilters$sectorN === void 0 ? void 0 : _queryFilters$sectorN.toLowerCase());
        });
        delete queryFilters.sectorName;
        queryFilters.sector = [selectedSector];
        setFilters(RealestateList_objectSpread({}, queryFilters));
      }
    }
  }),
      sectors = _useSectors.data;

  var _queryParserUrl = (0,query_string_helper/* queryParserUrl */.HL)(router.asPath),
      query = _queryParserUrl.query;

  var defaultState = RealestateList_objectSpread(RealestateList_objectSpread(RealestateList_objectSpread({}, form_util/* FormConfig.initialValues */.Z.initialValues), defaultFilters.filters), adaptQueryParams(query, props));

  var _useState3 = (0,react.useState)(defaultState),
      queryFilters = _useState3[0],
      setFilters = _useState3[1]; // Función que marca que el usuario ha interactuado con los filtros


  var markUserInteraction = function markUserInteraction() {
    hasUserInteracted.current = true;
  };

  var onFieldChange = function onFieldChange(field, value) {
    markUserInteraction(); // Marcar interacción

    var newFilters = RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), {}, (0,defineProperty/* default */.Z)({}, field, value));

    setFilters(newFilters);
  };

  var handleFiltersReset = function handleFiltersReset() {
    markUserInteraction(); // Marcar interacción

    setFilters(defaultState);
  };

  var onBusinessChange = function onBusinessChange(e) {
    markUserInteraction(); // Marcar interacción

    var value;

    if (e.target) {
      value = e.target.value;
    } else if (typeof e === "string") {
      value = e;
    }

    if (value == "sale") {
      setTitle("Quiero Comprar");
    } else {
      setTitle("Quiero Alquilar");
    }

    onFieldChange("businessTypes", value);
  }; // Modificar todas las demás funciones de change para marcar la interacción


  var onTypeChange = function onTypeChange(e) {
    markUserInteraction();
    var value = e.target.value;

    var typeProperty = (0,toConsumableArray/* default */.Z)(queryFilters.typeProperty);

    if (typeProperty.includes(value)) {
      var index = typeProperty.indexOf(value);
      typeProperty.splice(index, 1);
    } else {
      typeProperty.push(value);
    }

    onFieldChange("typeProperty", typeProperty);
  };

  var onParkingLotsChange = function onParkingLotsChange(e) {
    markUserInteraction();
    var value = e.target.value;

    if (value === queryFilters.parkings) {
      onFieldChange("parkings", "");
    } else {
      onFieldChange("parkings", value);
    }
  };

  var onBedroomsChange = function onBedroomsChange(e) {
    markUserInteraction();
    var value = e.target.value;

    var bedrooms = (0,toConsumableArray/* default */.Z)(queryFilters.bedrooms);

    if (bedrooms.includes(value)) {
      var index = bedrooms.indexOf(value);
      bedrooms.splice(index, 1);
    } else {
      bedrooms.push(value);
    }

    onFieldChange("bedrooms", bedrooms);
  };

  var onBathroomsChange = function onBathroomsChange(e) {
    markUserInteraction();
    var value = e.target.value;

    if (value === queryFilters.bathrooms) {
      onFieldChange("bathrooms", "");
    } else {
      onFieldChange("bathrooms", value);
    }
  };

  var onSectorsChange = function onSectorsChange(e, data) {
    markUserInteraction();
    var value = e.target.value;
    var newSector = data.find(function (x) {
      return x.id == value;
    });
    var sector = queryFilters.sector.map(function (x) {
      return {
        id: +x.id,
        description: x.description
      };
    });

    if (e.target.checked == false) {
      sector = sector.filter(function (x) {
        return x.id != +value;
      });
    } else {
      sector.push(newSector);
    }

    setFilters(RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), {}, {
      sector: sector
    }));
  };

  var onCurrencyChange = function onCurrencyChange(currencyType) {
    markUserInteraction();
    setFilters(RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), {}, {
      currencyType: currencyType,
      amountMin: "",
      amountMax: ""
    }));
  };

  var onAmountChange = function onAmountChange(eventValue, field) {
    markUserInteraction();
    var value = eventValue ? +eventValue : null;
    var amountMax;
    var amountMin;
    var currencyType;

    if (typeof field == "undefined" && (eventValue === null || eventValue === void 0 ? void 0 : eventValue.length) === 3) {
      amountMax = +eventValue[1];
      amountMin = +eventValue[0];
      currencyType = eventValue[2];
    } else {
      amountMax = field === "max" ? value : queryFilters.amountMax;
      amountMin = field === "min" ? value : queryFilters.amountMin;
    }

    setFilters(RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), {}, {
      currencyType: currencyType,
      amountMax: amountMax,
      amountMin: amountMin
    }));
  };

  var onOrderByChange = function onOrderByChange(e, orderBy) {
    markUserInteraction();

    var filters = RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), {}, {
      orderBy: orderBy,
      recent: 1
    });

    if (orderBy === "recent") {
      delete filters.orderBy;
    } else {
      delete filters.recent;
    }

    setFilters(RealestateList_objectSpread({}, filters));
  };

  var handleAdvancedFilters = function handleAdvancedFilters(values) {
    markUserInteraction();
    setFilters(RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), values));
  };

  var onLocationsChange = function onLocationsChange(e, value) {
    markUserInteraction();
    var locations = value;

    if (locations.length == 0) {
      setFilters(RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), {}, {
        sector: [],
        locations: locations
      }));
      return;
    }

    onFieldChange("locations", locations);
  };
  /**
   * Update selected city and sector filters if applicable.
   * This effect is triggered when the cities list is fetched, if sectorName is part of the query filters
   * the sector filter is updated with the corresponding sector object.
   */


  (0,react.useEffect)(function () {
    // Update selected city filter
    if (router.pathname === seo_const/* seoPathname */.G && cities !== null && cities !== void 0 && cities.length && queryFilters.cityName && !hasUserInteracted.current // Solo ejecutar durante la inicialización
    ) {
      var collator = new Intl.Collator("es", {
        sensitivity: "base"
      });
      queryFilters.locations = cities.filter(function (city) {
        return collator.compare(city.description, queryFilters.cityName.replaceAll("-", " ")) == 0;
      }); // Update selected sector filter

      if (queryFilters.sectorName && queryFilters.locations.length) setCityId(queryFilters.locations[0].id);
      setFilters(RealestateList_objectSpread({}, queryFilters));
    }
  }, [cities]);

  var getActualUrl = function getActualUrl(filters) {
    var query = (0,realestate_filters_helper/* parseRealestateFiltersToUrl */.Y_)(filters);

    if (router.asPath.includes("/propiedades/comprar")) {
      return "/propiedades/comprar" + "?" + query;
    } else if (router.asPath.includes("/propiedades/alquilar")) {
      return "/propiedades/alquilar" + "?" + query;
    } else if (router.asPath.includes("/collection/propiedades")) {
      return "/collection/propiedades" + "?" + query;
    } else {
      return "/propiedades" + "?" + query;
    }
  }; // Efecto para marcar que el primer renderizado ha terminado


  (0,react.useEffect)(function () {
    if (isFirstRender.current && router.isReady) {
      // Esperar un poco para asegurar que todos los datos estén cargados
      var timer = setTimeout(function () {
        isFirstRender.current = false;
      }, 500);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [router.isReady]);
  var ObservableUrlFilters = (0,lodash.debounce)(function (filters) {
    // Solo actualizar URL si:
    // 1. No es el primer renderizado
    // 2. El usuario ha interactuado con los filtros
    if (!isFirstRender.current && hasUserInteracted.current) {
      var newUrl = getActualUrl(filters);

      if (newUrl && router.asPath !== newUrl) {
        router.push(newUrl, undefined, {
          shallow: true
        });
      }
    }
  }, 300); // Aumentar ligeramente el debounce para mejor UX

  (0,react.useEffect)(function () {
    ObservableUrlFilters(queryFilters);
  }, [JSON.stringify(queryFilters)]);

  var updateFilters = function updateFilters(filters) {
    markUserInteraction(); // Marcar interacción

    setFilters(RealestateList_objectSpread(RealestateList_objectSpread({}, queryFilters), filters));
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, title && (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, title)), (0,emotion_react_browser_esm/* jsx */.tZ)(proyectos_Filters, {
    filters: queryFilters,
    onBusinessChange: onBusinessChange,
    onTypeChange: onTypeChange,
    onParkingLotsChange: onParkingLotsChange,
    onBedroomsChange: onBedroomsChange,
    onSectorsChange: onSectorsChange,
    onBathroomsChange: onBathroomsChange,
    handleAdvancedFilters: handleAdvancedFilters,
    onCurrencyChange: onCurrencyChange,
    onAmountChange: onAmountChange,
    onLocationsChange: onLocationsChange,
    collection: collection,
    handleFiltersReset: handleFiltersReset
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(ProjectList, (0,esm_extends/* default */.Z)({}, defaultFilters, {
    filters: queryFilters,
    updateFilters: updateFilters,
    isCollection: collection,
    orderByFiltersHandler: onOrderByChange
  })));
}

/* harmony default export */ var proyectos_RealestateList = (RealestateList);

/***/ }),

/***/ 47364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18872);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


var _excluded = ["message"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function LoadingBubbles(props) {
  var _props$message = props.message,
      message = _props$message === void 0 ? "Cargando más" : _props$message,
      rest = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Loading, rest, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    style: {
      marginRight: 15
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("img", {
    src: "/icons/loading-icon.svg",
    alt: "loading"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", null, message)));
}

/* harmony default export */ __webpack_exports__["Z"] = (LoadingBubbles);
var spinner = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)( true ? {
  name: "b7n1on",
  styles: "0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"
} : 0);
var centerStyles = "\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999;\n";

var Loading = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e76jmd50"
} : 0)(function (props) {
  return "\n  width: 100%;\n  background-color: \"transparent\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 600;\n  color:gray;\n   & img {\n    animation: ".concat(spinner, " 2s infinite;\n  }\n  ").concat(props.center ? centerStyles : '', "\n");
},  true ? "" : 0);

/***/ }),

/***/ 4674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ seoPathname; }
/* harmony export */ });
var seoPathname = "/[...dynamicSEO]";

/***/ }),

/***/ 16371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ titleDynamicProperties; }
/* harmony export */ });
/* unused harmony export seoTitleHandler */
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17674);
/* harmony import */ var _const_property_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86465);
/* harmony import */ var _const_seo_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4674);



var titleDynamicProperties = function titleDynamicProperties(router) {
  var params = router.asPath.split('?')[0].split("/");

  if (/^.*(\+|:|\bq\b|%22)+.*$/.test(router.asPath)) {
    return "Resultados de b\xFAsqueda";
  } else if (router.pathname === _const_seo_const__WEBPACK_IMPORTED_MODULE_1__/* .seoPathname */ .G) {
    return seoTitleHandler(params.join('/'));
  } else if (params.length == 6) {
    return "".concat(params[2], " de ").concat(params[3], "s en ").concat(params[5].replaceAll('-', " "), ", ").concat(params[4].replaceAll('-', " "), " ");
  } else if (params.length == 5) {
    return "".concat(params[2], " de ").concat(params[3], "s en ").concat(params[4].replaceAll('-', " "));
  } else if (params.length == 4) {
    return "".concat(params[2], " de ").concat(params[3], "s");
  } else if (params.length == 3) {
    return "Propiedades en ".concat(params[2]);
  }
};
var seoTitleHandler = function seoTitleHandler(path) {
  var _CPropertyTypes$find;

  var _path$substring$split = path.substring(1).split("/"),
      _path$substring$split2 = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_path$substring$split, 4),
      businessTypes = _path$substring$split2[0],
      propertyType = _path$substring$split2[1],
      city = _path$substring$split2[2],
      sector = _path$substring$split2[3];

  var propertyTypePlural = (_CPropertyTypes$find = _const_property_types__WEBPACK_IMPORTED_MODULE_0__/* .CPropertyTypes.find */ .Rl.find(function (x) {
    return x.name.toLowerCase() == propertyType.toLowerCase().replace(/-/g, " ");
  })) === null || _CPropertyTypes$find === void 0 ? void 0 : _CPropertyTypes$find.plural;
  var result = businessTypes + " de " + propertyTypePlural;

  if (city) {
    result += " en " + city.replace(/-/g, " ");
    if (sector) result += ", " + sector.replace(/-/g, " ");
  } else {
    result += " en República Dominicana";
  }

  return result + " ";
};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 57761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      } else {
        options = {
          passive: false
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports["default"] = InfiniteScroll;
module.exports = exports['default'];


/***/ }),

/***/ 246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(57761)


/***/ }),

/***/ 59403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(52924);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(9499);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    const {
      isFetching,
      isRefetching
    } = result;
    const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
    const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage,
      isFetchingPreviousPage,
      isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 4 modules
var useBaseQuery = __webpack_require__(67187);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ })

}]);